import exportFromJSON from 'export-from-json';
import React from "react";
import { MultiSelect } from 'react-multi-select-component';
import { connect } from 'react-redux';
import { Panel, PanelList, Tab, TabList, Tabs } from 'react-tabtab';
import { bindActionCreators } from 'redux';
import { setInsightFunction } from '../../actions/index';
import ReactDOMServer from "react-dom/server";
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from '../../../adminpanel/components/commonComponents/ModalComponent';
import { setKpiColumnConfig, removeFilter, setDashboardId, setFilter, set_disp_objects, getGlobalFilters } from '../../actions/index';
import Chart from '../ChartComponents/component/Chart';
// import NoDataFound from '../commonComponents/NoDataFound';
import TopModalComponent from '../commonComponents/TopModalComponent';
import * as darkStyle from '../PinboardComponents/tabs-style/index.dark';
import TableData from '../ReportComponents/component/TableData.js';
import SummaryData from '../SummaryComponents/component/SummaryData';
import { DBService } from '../SummaryComponents/component/IndexedDB';
// import SettingsComponent from './SettingsComponent';
import LoadingComponent from "../commonComponents/LoadingComponent";
import * as customStyle from './tabs-style/index.normal';
import { ExportToCsv } from 'export-to-csv';
import { toExcel } from 'to-excel';
import Pagination from "./Pagination";
import SkeletonCard from "../commonComponents/Skeleton";
import './pinboard.css'
import CalenderComponent from "../commonComponents/CalenderComponent";
import BreadcrumbComponent from '../../../adminpanel/components/commonComponents/BreadcrumbComponent';
import FilterComponent from '../commonComponents/FilterComponent';
import AsyncSelect from 'react-select/async';
import NoDataFound from '../commonComponents/NoDataFound.js';


var actionType, dropdownStatus = null, globalDashboardID = null, dashboardFilterValues = null, dashboardComponentsData = null, wrappedChar, dynamicStartDate = null, dynamicEndDate = null, editComponentModal = null, filtersChanged = false
class Pinboard extends React.Component {
    constructor(props) {
        super(props);
        this._db = new DBService();
        this.state = { dashboard_id: props.id_dashboard, modalName: null, pinboardEventName: null, dashboardFilter_options: {}, selectedFilters: {}, filtersVisible: false, currentPage: 1, editComponentFilterProps: {}, ...props };
        this.deletePin = this.deletePin.bind(this);
        this.enterFullScreen = this.enterFullScreen.bind(this);
        this.handle_save_dashboard = this.handle_save_dashboard.bind(this);
        this.handle_edit_chart_title = this.handle_edit_chart_title.bind(this);
        this.information = this.information.bind(this);
        this.setKpiColumnConfig = this.setKpiColumnConfig.bind(this);
        this.dashboard_change_handle = this.dashboard_change_handle.bind(this);
        this.openrefs = this.openrefs.bind(this);
        this.edit_handle = this.edit_handle.bind(this);
        this.get_components = this.get_components.bind(this);
        this.save = this.save.bind(this);
        this.getfiltervalues = this.getfiltervalues.bind(this);
        this.addDashboardFilter = this.addDashboardFilter.bind(this);
        this.dimensionFilterhandle = this.dimensionFilterhandle.bind(this);
        this.fetchPropertyData = this.fetchPropertyData.bind(this);
        this.dashboardreindex = this.dashboardreindex.bind(this);
        this.dashboardTabArray = [];
        this.downloadHandleActionSummary = this.downloadHandleActionSummary.bind(this);
        this.handleDashboardFilters = this.handleDashboardFilters.bind(this);
        this.handleApplyFilters = this.handleApplyFilters.bind(this);
        this.displayFilters = this.displayFilters.bind(this);
        this.getMenuOptions = this.getMenuOptions.bind(this);
        this.globalFilterInputHandler = this.globalFilterInputHandler.bind(this);
        this.updateGlobalFilters = this.updateGlobalFilters.bind(this);
        this.dashboardFilterCancelHandler = this.dashboardFilterCancelHandler.bind(this)
    }
    fetchPropertyData = (input, callback) => {
        try {
            asyncFilter(input, 'propertyLabelDashboard', callback, this.props.authData, this.props.match.path);
        } catch (error) {
            console.log('-----Error In fetchPropertyData ----')
            console.log(error)
        }
    }
    dimensionFilterhandle(e) {
        this.setState({ dimensionFilter: e });
    }
    addDashboardFilter() {
        let processedFilter = { "global_filter": {}, "default_filter": [], "date_condition": "" };
        let innerData = {};
        let selectedDimensions = this.state.dimensionFilter;
        var that = this;

        processedFilter["global_filter"] = selectedDimensions ? selectedDimensions.reduce((acc, item, index) => {
            let impact = []
            if (index !== 0) {
                impact.push(selectedDimensions[index - 1]['value']);
            }
            acc[item.value] = { "filter": [], "label": item.label, "impact": impact }
            return acc;
        }, innerData) : [];

        let dashboard_id = this.state.dashboard_id;

        var dataSet = this.props.dataSet;

        let params = { siteId: dataSet.siteId, toolId: dataSet.toolId }
        let postData = { dashboard_id: dashboard_id, filters: JSON.stringify(processedFilter), userId: this.props.authData.userId }
        CallAPI('POST', "/app/saveDashboardFilters", postData, params, 0, function (response) {
            if (response.status) {
                alert(response.information);
                jQuery('#dashboardFilterModal').modal('toggle');
                that.handleModalEvent(null);
            }
            // that.get_components(that.state.dashboard_id, dataSet, "Basic " + btoa(that.props.authData.userId + ":"));
            window.location.reload();
        }, this.props.authData)
    }
    getfiltervalues = (filter_array, include_array) => {
        var indexedDB = this._db
        var that = this;
        const tempObject = {};
        dropdownStatus = true;
        try {
            var include = decodeURIComponent(that.state.include);
            if (include_array) {
                include = include_array
            }
            if (default_filter) {
                include += include ? "," : "";
                include += default_filter;
            }
            Object.keys(filter_array).forEach(function (innerData, index) {
                var dataset = JSON.parse(localStorage.Dataset);
                // let impact = dashboard_filters[innerData].impact;
                // let exclude = null
                let queryParams = {
                    // label: innerData,
                    // selectedProperty: innerData, 
                    // dashboard: true, 
                    siteId: dataset.siteId,
                    toolId: dataset.toolId,
                    pattern: innerData,
                    type: 2,
                    exactMatch: true
                    // breakup: include,
                    // exclude: exclude, 
                    // sql: date_sql, 
                    // impact: impact ? impact.toString() : null
                }
                //IndexedDB Code
                let idbQueryParams = JSON.parse(JSON.stringify(queryParams))
                idbQueryParams['userId'] = that.props.authData ? that.props.authData.userId : null
                let final_data = null;
                indexedDB.get('DashboardFilters', JSON.stringify(idbQueryParams)).then(e => {
                    if (e) {
                        final_data = JSON.parse(e.object);
                        dashboard_filters[innerData].filter = final_data;
                        tempObject[innerData] = final_data
                        if (Object.keys(filter_array).length === Object.keys(tempObject).length) {
                            dropdownStatus = false;
                            that.setState({ ...that.state, dashboardFilter_options: tempObject })
                        }
                    } else {
                        CallAPI('GET', '/app/searchElastic', null, queryParams, 0, function (response) {
                            if (response && response.length >= 0) {
                                final_data = response;
                                indexedDB.put("DashboardFilters", JSON.stringify(final_data), JSON.stringify(idbQueryParams))
                                dashboard_filters[innerData].filter = final_data;
                                tempObject[innerData] = final_data
                                if (Object.keys(filter_array).length === Object.keys(tempObject).length) {
                                    dropdownStatus = false;
                                    that.setState({ ...that.state, dashboardFilter_options: tempObject })
                                }
                            }
                        }, that.props.authData)
                    }
                })
            })
        } catch (err) {
            console.log(err);
        }
    }
    save() {
        var that = this;
        var serializedData = [];
        grid.engine.nodes.map(function (node, index) {
            if (node.id) {
                serializedData.push({
                    x: node.x,
                    y: node.y,
                    id: node.id,
                    width: node.width,
                    height: node.height
                });
            }
        });

        var dataset = JSON.parse(localStorage.Dataset);

        let params = { toolId: dataset.toolId, siteId: dataset.siteId, dashboard_id: id_dashboard, type: "local" }
        if (window.location.pathname.split('/')[1] == "globaldashboards") {
            params = { ...params, type: "global" }
        }
        let postData = {
            'dashboard_json': serializedData,
            'userId': this.props.authData.userId
        }
        CallAPI('POST', "/app/save_dashboard_sequence", postData, params, 0, function (response) {
            document.getElementById("edit_save_button").innerHTML = "Edit";
            document.getElementById("edit_save_button").onclick = that.edit_handle;
            document.getElementById("cancel_edit_button").style.display = "none";
            that.get_components(id_dashboard, dataset, "Basic " + btoa(that.props.authData.userId + ":"));
        }, this.props.authData)
    }
    edit_handle = (e) => {
        var that = this;
        if (e.target.innerHTML === "Edit") {
            document.getElementById("edit_save_button").innerHTML = "Save";
            document.getElementById("edit_save_button").onclick = this.save;
            jQuery('#edit_save_button').attr('data-original-title', "Save Changes")

            document.getElementById("cancel_edit_button").style.display = "inline-block";

            grid.movable('.grid-stack-item', true);
            // if(this.state.split_type)
            //     grid.cellWidth(this.state.split_type=="half"?6:12);
            grid.resizable('.grid-stack-item', true);
            disable_zoom_charts();
        } else if (e.target.innerHTML === "Cancel") {
            location.reload();
        }
    }
    openrefs = () => {

        if (this.props.filter == true || (this.state.filter == "null" && defaultFilterFlag == '1')) {
            defaultFilterFlag = '0'
            this.props.removeFilter()
        } else {
            defaultFilterFlag = '1'
            this.props.setFilter()
        }
        // this.refs.alfredComponentRef.openSetting();
        dragcomplete();
    }
    setKpiColumnConfig = (item,url) => {
        let that = this;
        if (item.parameters?.kpiMonitoring == true || item.parameters?.kpiMonitoring == "true") {
            that.props.kpiColumnConfig(item?.parameters?.kpiColumnConfig)
        }
        window.open(url, '_blank');
    }
    information = (index, type) => {
        index = type && type.toLowerCase() == "report" ? ++index : index;
        if (index == "show" || index == "hide") {
            let option = index == 'show' ? "" : "none"
            jQuery(".dashboard_footer_class").css('display', `${option}`);
            document.getElementById("show_date_info").style.display = index == 'show' ? "none" : "";
            document.getElementById("hide_date_info").style.display = option;
        } else {
            let option = document.getElementById("dashboard_footer_" + index).style.display == "none" ? "" : "none";
            document.getElementById("dashboard_footer_" + index).style.display = option;
        }
    }
    handle_edit_chart_title = (index, type) => {
        if (type == "edit") {
            jQuery(`#title_charts_value_${index}`).css("display", "block")
            jQuery(`#title_charts_${index}`).css("display", "none")
        } else if (type == "cancel") {
            jQuery(`#title_charts_value_${index}`).css("display", "none")
            jQuery(`#title_charts_${index}`).css("display", "block")
        }
    }
    handle_save_dashboard = (index) => {
        var value = document.getElementById(`chart_title_${index}`).value;
        var params = { dashboard_id: this.props.id_dashboard, pin_id: index, pin_text: value, toolId: this.props.dataSet.toolId, siteId: this.props.dataSet.siteId }
        var that = this
        let checkValidity = true
        checkValidity = checkValidity ? (checkSpecialChars(value, 'pinInsert') ? false : true) : false
        if (checkValidity === false) {
            alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
        } else {
            CallAPI('POST', "/app/savepintitle", {}, params, 0, function (response) {
                jQuery(`#title_charts_value_${index}`).css("display", "none")
                jQuery(`#title_charts_${index}`).css("display", "block")
                document.getElementById(`title_charts_${index}`).innerHTML = value;
                that.dashboard_change_handle(id_dashboard);
            }, this.props.authData)
        }
    }
    deletePin = (id) => {
        if (confirm('Are you sure you want to delete?')) {
            // var fd = new FormData();
            // fd.append('id', id);
            var that = this;
            var userId = this.props.authData.userId;
            var authorization_value = null;
            authorization_value = "Basic " + btoa(userId + ":");
            var dataset = JSON.parse(localStorage.Dataset);
            let postData = { 'userId': userId }
            let params = {
                'toolId': dataset.toolId,
                'siteId': dataset.siteId,
                'id': id,
                'dashboard_id': id_dashboard
            }
            CallAPI('POST', '/app/pinDelete', postData, params, 0, function (response) {
                checkIfSessionTimedOut(response);
                alert('Component Deleted.');
                // that.dashboard_change_handle(id_dashboard, 'pinDelete');
                that.dashboard_change_handle(id_dashboard);
            }, this.props.authData)

            /* Commented below jQuery.ajax call & changed it to above CallAPI method */
            // jQuery.ajax({
            //     type: 'POST',
            //     url: `/app/pinDelete?toolId=${dataset.toolId}&siteId=${dataset.siteId}&id=${id}`,
            //     headers: { Authorization: authorization_value },
            //     dataType: 'json',
            //     data: postData,
            //     contentType: false,
            //     processData: false,
            //     success: function (response) {
            //         checkIfSessionTimedOut(response)
            //         alert('Pin Deleted.');
            //         that.dashboard_change_handle(id_dashboard, 'pinDelete');
            //     }.bind(this)
            // });
        }
    }
    enterFullScreen = (index) => {
        var domGrid = document.getElementById('myGridTop' + (index + 1));
        domGrid.webkitRequestFullscreen();
        jQuery('#myGridTop' + (index + 1)).css('max-height', '');
        jQuery(".ag-row-animation").css('max-height', 'none');
        jQuery('#myGridTop' + (index + 1)).height("700px");
    }
    get_components(dashboard_id, dataset, authorization_value, type = null) {
        
        var that = this;
        actionType = null;
        this.setState({ dashboardComponents: -1 })
        var dashboard_group = this.state.dashboardComponents.length && this.state.dashboardComponents != -1 ? this.state.dashboardComponents[0]['dashboard_group'] : 'Default'
        let params = { 'idDashboard': dashboard_id, 'siteId': dataset.siteId, 'toolId': dataset.toolId, 'type': type }
        if (screen_width <= mobile_width || jQuery(document).width() < tablet_width ) {
            params.mobileView = true
        }
        let postData = { userId: that.props.authData.userId }
        setTimeout(() => {
            CallAPI('POST', '/app/getDashboardComponents', postData, params, 0, function (response) {
                checkIfSessionTimedOut(response)
                checkIfMaintenanceModeOn(response)
                dashboardComponents = response;
                let dimensionFilter = dashboardComponents.length && JSON.parse(dashboardComponents[0].filters)
                    ? Object.keys(JSON.parse(dashboardComponents[0].filters).global_filter).map(function (innerData, index) {
                        return { "label": JSON.parse(dashboardComponents[0].filters).global_filter[innerData].label, "value": innerData }
                    })
                    : []

                if (type == 'pinDelete' || !dashboardComponents.length) {
                    actionType = 'pinDelete_NoData';
                }
                if (dashboardComponents[0] && dashboardComponents[0].filters) {
                    let parsedFilters = JSON.parse(dashboardComponents[0].filters)
                    dashboard_filters = parsedFilters && parsedFilters.global_filter ? parsedFilters.global_filter : []
                    default_filter = parsedFilters && parsedFilters.default_filter ? parsedFilters.default_filter.toString() : [];
                    date_sql = parsedFilters && parsedFilters.date_condition ? parsedFilters.date_condition : [];
                }else if(dashboardComponents[0] && dashboardComponents[0].filters == null){
                    dashboard_filters = []
                    default_filter = []
                    date_sql = []
                }
                let includeToUse = decodeURIComponent(that.state.include);
                if (Array.isArray(dashboard_filters) === false) {
                    if (Object.keys(dashboard_filters).length > 0) {
                        that.getfiltervalues(dashboard_filters, includeToUse)
                    }
                }
                globalDashboardID = dashboard_id;
                if (that.state.dimensionFilter && that.state.dimensionFilter.length === 1 && dimensionFilter.length === 1) {
                    if (that.state.dimensionFilter[0].label === dimensionFilter[0].label) {
                    }
                } else that.setState({ include: null, includeArray: [] })
                // if (dashboardComponents.length && dashboardComponents[0].type === "local") {
                // window.history.pushState({}, null, `/pinboard?dashboard_id=${dashboard_id}`);    // Commented to use other params 
                // }
                that.props.setDashboardId({ "id_dashboard": dashboard_id, "report_name": dashboardComponents[0].report_name, "dashboardComponents": dashboardComponents, "group": dashboardComponents.length ? dashboardComponents[0].dashboard_group : dashboard_group, dimensionFilter: dimensionFilter, dashboard: { startDate: null, endDate: null }, breakup: null, property: null });
                window.history.pushState({}, null, `/pinboard?dashboard_id=${dashboard_id}`);
            }, this.props.authData)

            /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
            // jQuery.ajax({
            //     type: 'POST',
            //     data: {
            //         userId: that.props.authData.userId
            //     },
            //     url: `/app/getDashboardComponents?idDashboard=${dashboard_id}&siteId=${dataset.siteId}&toolId=${dataset.toolId}&type=${type}`,
            //     async: false,
            //     headers: { Authorization: authorization_value },
            //     success: function (response) {
            //         checkIfSessionTimedOut(response)
            //         dashboardComponents = JSON.parse(response);
            //         let dimensionFilter = dashboardComponents.length && JSON.parse(dashboardComponents[0].filters) ? Object.keys(JSON.parse(dashboardComponents[0].filters).global_filter).map(function (innerData, index) {
            //             return { "label": JSON.parse(dashboardComponents[0].filters).global_filter[innerData].label, "value": innerData }
            //         }) : []

            //         if (type == 'pinDelete' && !dashboardComponents.length) {
            //             actionType = 'pinDelete_NoData';
            //         }
            //         dashboard_filters = dashboardComponents[0].filters ? JSON.parse(dashboardComponents[0].filters).global_filter : [];
            //         default_filter = dashboardComponents[0].filters ? JSON.parse(dashboardComponents[0].filters).default_filter.toString() : [];
            //         date_sql = dashboardComponents[0].filters ? JSON.parse(dashboardComponents[0].filters).date_condition : [];
            //         let includeToUse = decodeURIComponent(that.state.include);
            //         if (Array.isArray(dashboard_filters) === false) {
            //             if (Object.keys(dashboard_filters).length > 0) {
            //                 that.getfiltervalues(dashboard_filters, includeToUse)
            //             }
            //         }
            //         globalDashboardID = dashboard_id;
            //         that.props.setDashboardId({ "id_dashboard": dashboard_id, "dashboardComponents": dashboardComponents, "group": dashboardComponents.length ? dashboardComponents[0].dashboard_group : dashboard_group, dimensionFilter: dimensionFilter, dashboard: { startDate: null, endDate: null }, breakup: null, property: null });
            //         if (dashboardComponents.length && dashboardComponents[0].type === "local") {
            //             window.history.pushState({},null, `/pinboard?dashboard_id=${dashboard_id}`);
            //         }
            //     }
            // });
        }, 500);
    }
    handleSyncClick = (toolData = null) => {
        let toolID = toolData ? toolData.toolId : this.props.dataSet.toolId
        let indexedDB = this._db
        IDBStoreNames.forEach((e) => {
            if (toolID) {
                indexedDB.deleteByToolId(e, toolID);
            }
        })
        window.localStorage.setItem('redirectTo', JSON.stringify(location));
        handleChangeCalled = false;
        changeDatasetFunction(toolData ? toolData : toolID);
    }
    dashboard_change_handle(e, type = null) {
        let url = window.location.href;
        let newUrl = new URL(url);
        let params = new URLSearchParams(newUrl.search);

        // Remove the "include" parameter
        params.delete("include");

        // Update the URL without reloading the page (optional)
        newUrl.search = params.toString();
        window.history.replaceState({}, '', newUrl);
        this.setState({
            selectedFilterValues:[],
            selectedFilters:[]
        })
        var dataset = JSON.parse(localStorage.Dataset);
        var that = this;
        var userId = this.props.authData ? this.props.authData.userId : null;
        dataset.userId = userId;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");
        filtersChanged = false;
        if (e) {
            if (document.getElementById("edit_save_button")) {
                document.getElementById("edit_save_button").innerHTML = "Edit";
                document.getElementById("edit_save_button").onclick = that.edit_handle;
                document.getElementById("cancel_edit_button").style.display = "none";
            }
            id_dashboard = e;
            this.get_components(id_dashboard, dataset, authorization_value, type);
        } else this.get_components(this.state.dashboard_id ? this.state.dashboard_id : e, dataset, authorization_value, type);
    }
    componentDidCatch(error, info) {
        this.setState({
            pageError: true
        })
    }
    handleInitialData(response, that) {
        if (window.location.pathname.split('/')[1] == "globaldashboards") {
            dashboard_options = response.allDashboards ? response.allDashboards.dashbordGroups : response.dashboard;
            dashboard_options = dashboard_options.filter(innerData => innerData.type == "global");
            // }else dashboard_options = response.dashboard ? response.dashboard : that.props.allDashboards.dashbordGroups;
        } else dashboard_options = response.dashboard ? response.dashboard : that.props.dashbordGroups; // WHen Choose dimension changed on 1 dashboard other dashboard groups where getting issue when changed
        var group = that.state.group && that.state.group != 'null' ? that.state.group : null;
        group = group ? decodeURIComponent(group) : null;
        let dashboard_id = that.state.dashboard_id ? that.state.dashboard_id : dashboard_options[0].idDashboard;
        let dashboardType;
        let dashboardComponents = that.state.dashboardComponents;
        var req_dashboards = dashboard_options.filter(function (innerData) {
            if (group && dashboardComponents!=-1 ) {
                if (innerData.dashboard_group == decodeURIComponent(group))
                    return innerData;
            } else {
                if (innerData.idDashboard == dashboard_id)
                    return innerData;
            }
        })
        var lowestSequenceDashboard = req_dashboards.length > 0 && req_dashboards.reduce(function (previous, current) {
            return previous.dashboard_dequence < current.dashboard_dequence ? previous : current;
        });

        if (refineURLData(decodeURIComponent(getParameters('question'))) && id_dashboard) {
            dashboard_id = id_dashboard
            dashboard_options.map(function (innerData) {
                if (innerData.idDashboard == dashboard_id) {
                    group = innerData.dashboard_group
                }
                dashboardType = innerData.type;
            })
        }
        // Changed below condition as on refresh on any tab it was switching to first tab only
        // Also checked the condition of dashboard group as it is causing error on dashbaord group switch
        // if (!that.state.dashboard_id && that.props.id_dashboard) {
        else if (that.state.dashboard_id && that.props.id_dashboard && that.state.dashboardComponents[0] && (that.state.group === that.state.dashboardComponents[0].dashboard_group)) {
            dashboard_id = that.props.id_dashboard
            dashboard_options.map(function (innerData) {
                if (innerData.idDashboard == dashboard_id) {
                    group = innerData.dashboard_group
                }
                dashboardType = innerData.type;
            })
        } else {
            if ((dashboard_options.length >= 1 && dashboardComponents.length == 0) || (dashboard_options.length >= 1 || that.state.dashboardComponents[0] && that.state.dashboardComponents[0].dashboard_group != that.state.group)) {
                req_dashboards = req_dashboards.length > 0 ? req_dashboards : dashboard_options;
                dashboard_id = lowestSequenceDashboard.idDashboard ? lowestSequenceDashboard.idDashboard : req_dashboards[0].idDashboard;
                dashboardType = lowestSequenceDashboard.type ? lowestSequenceDashboard.type : req_dashboards[0].type;
            }
        }

        group = group ? group : lowestSequenceDashboard.dashboard_group;

        // metricGlobal = jQuery.parseJSON(response.metric);

        var changeProperty = false, propertytoChange = null, property_disp = [];
        if (response.dashboardProperty) {
            property_disp = JSON.parse(response.dashboardProperty);
            changeProperty = true;
            propertytoChange = property_disp && property_disp[0] ? property_disp[0].value : null;
        }
        // property.unshift({ label: 'Default', value: '', type: "propertyLabel" });
        metricFunction = response.metricFunction ? Array.isArray(response.metricFunction) ? response.metricFunction : JSON.parse(response.metricFunction) : [];
        metricPossibleCombinations = createCombination(metricGlobal, metricFunction);

        var allHierarchyValues = response.allHierarchyValues ? JSON.parse(response.allHierarchyValues) : response.allHierarchyValues;
        if (allHierarchyValues) {
            allHierarchyValues['property'] = allHierarchyValues['property'] ? allHierarchyValues['property'].split(',') : [];
        }

        var breakup = JSON.parse(response.filter);
        var breakupvalue = '';
        if (breakup && Array.isArray(breakup)) {
            breakup.forEach(element => {
                if (breakupvalue)
                    breakupvalue += "," + element.value;
                else breakupvalue = element.value;
            });
        }
        globalDashboardID = dashboard_id;
        that.dashboard_change_handle(dashboard_id, dashboardType);
    }
    componentWillMount() {
        filtersChanged = false
        window.onload = function () {
            filtersAppliedFlag = true;
        }
        var that = this, dataset = JSON.parse(localStorage.Dataset);
        if (getParameters('nav') !== 'new') {
            id_dashboard = refineURLData(decodeURIComponent(getParameters('question'))) ? id_dashboard : this.state.id_dashboard
        }

        var userId = this.props.authData ? this.props.authData.userId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");

        let case1 = this.props.initialDataApiFlag
        let case2 = !this.state.dashboardComponents[0] || this.state.dashboardComponents[0].dashboard_group != this.state.group || this.state.dashboardComponents[0].idDashboard != this.props.id_dashboard

        if (case1 || case2) {
            if (case1) {
                // tryCatch(this, this.handleInitialData)
                try {
                    this.handleInitialData(this.props, that);
                } catch (error) {
                    console.error("------- Error in handleInitialData ---------");
                    console.error(error);
                }
            } else if (case2) {
                this.setState({
                    filter: [],
                    includeArray: [],
                    dimensionFilter: this.props.dimensionFilter,
                    dashboardComponents: -1,
                    selectedFilters: this.props.selectedFilterValues ? this.props.selectedFilterValues : {}
                })

                let params = { filter: that.state.breakup, property: that.state.property, siteId: dataset.siteId, toolId: dataset.toolId ? dataset.toolId : this.props.dataResult[0].toolId }
                // let postData = { 'userId': userId }
                let postData = null
                CallAPI('get', '/app/initialData', postData, params, 0, function (response) {
                    // response = response.data;
                    // tryCatch(this, this.handleInitialData)
                    try {
                        that.handleInitialData(response, that);
                    } catch (error) {
                        console.error("------- Error in handleInitialData ---------");
                        console.error(error);
                    }
                }, this.props.authData)
            }
        } else {
            if (this.state.dashboardComponents !== -1 && this.state.dashboardComponents.length > 0) {
                dashboard_filters = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).global_filter : [];
                default_filter = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).default_filter.toString() : [];
                date_sql = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).date_condition : [];
                var includeToUse = decodeURIComponent(this.state.include);
                if (Array.isArray(dashboard_filters) === false) {
                    if (Object.keys(dashboard_filters).length > 0) {
                        this.getfiltervalues(dashboard_filters, includeToUse);
                    }
                }
            }
            this.setState({
                filter: [],
                includeArray: [],
                dimensionFilter: this.props.dimensionFilter,
                dashboardComponents: this.state.dashboardComponents,
                selectedFilters: this.props.selectedFilterValues ? this.props.selectedFilterValues : {}
            })
        }
    }
    componentDidMount() {
        if (grid !== null && grid !== undefined) {
            grid.destroy([true])
        }
        grid = GridStack.init({ disableDrag: true, disableResize: true });
       
        dragcomplete();
        let PanelListParent = document.getElementById("react-tabtab-panel-0") && document.getElementById("react-tabtab-panel-0").parentElement;
        if (this.props.dashboardUIType == 'tabs' && PanelListParent) {
            PanelListParent.style.paddingTop = "7px"
            PanelListParent.style.marginLeft = "-10px"
            PanelListParent.style.width = "101.5%"
        }
        
        if (window.bootstrap) {
            const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
            popoverTriggerList.forEach((popover) => new window.bootstrap.Popover(popover));
          } else {
            console.error("Bootstrap is not loaded. Make sure the script is included in index.html.");
          }

    }
    componentDidUpdate(prevProps, prevState) {
        grid = GridStack.init({ disableDrag: true, disableResize: true });
        dragcomplete();
        let PanelListParent = document.getElementById("react-tabtab-panel-0") && document.getElementById("react-tabtab-panel-0").parentElement;
        if (this.props.dashboardUIType == 'tabs' && PanelListParent) {
            PanelListParent.style.paddingTop = "7px"
            PanelListParent.style.marginLeft = "-10px"
            PanelListParent.style.width = "101.5%"
        }
        if (prevState.currentPage !== this.state.currentPage) {
            let element = document.getElementById('mainDIVS')
            setTimeout(() => {
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth"
                    });
                }
            }, 1000);
        }
        // if (this.state.dashboardComponents !== -1 && this.state.dashboardComponents.length > 0) {
        //     if (prevState.include !== this.state.include && prevState.includeArray.length !== this.state.includeArray.length) {
        //         dashboard_filters = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).global_filter : [];
        //         default_filter = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).default_filter.toString() : [];
        //         date_sql = this.state.dashboardComponents[0].filters ? JSON.parse(this.state.dashboardComponents[0].filters).date_condition : [];
        //         var includeToUse = decodeURIComponent(this.state.include);
        //         if (Array.isArray(dashboard_filters) === false) {
        //             if (Object.keys(dashboard_filters).length > 0) {
        //                 this.getfiltervalues(dashboard_filters, includeToUse);
        //             }
        //         }
        //     }
        // }
        this.reHeightGrid()

    }
    componentWillReceiveProps(nextProps) {
        if (id_dashboard) {
            this.setState({ ...nextProps, id_dashboard: id_dashboard, dashboard_id: id_dashboard });
            if (getParameters('nav') == 'new') {
                this.dashboard_change_handle(id_dashboard)
            }
            // this.dashboardreindex(id_dashboard)
        }
    }
    downloadHandleActionSummary = (e, index) => {
        e.preventDefault();
        var fileName = document.getElementById(`exportFileName_${index}_form_data`).value;
        var exportType = document.getElementById(`exportType_${index}_form_data`).value;
        let checkValidity = true
        checkValidity = checkValidity ? (checkSpecialChars(fileName) ? false : true) : false
        if (checkValidity === false) {
            alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
            jQuery(`#exportSettings_${index}`).trigger("reset")
        } else {
            if (fileName) {
                var data = [];
                for (let i = 0; i < summaryData[index].length; i++) {
                    data.push({
                        "Name": summaryData[index][i].description,
                        "Value": summaryData[index][i].data,
                    });
                }
                exportFromJSON({ data, fileName, exportType })
                document.getElementById(`exportFileName_${index}_form_data`).value = "";
                jQuery(`#exportSettings_${index}`).modal("hide")
            } else {
                alert("Please type Filename");
            }
        }
    }
    handleEditComponent = (item, startDate, endDate, property_disp, includeDisp, excludeDisp, selectedMetricDisp, selectedBreakUpDisp) => {
        let that = this
        const filterProps = {
            authData: that.props.authData,
            datasetDetails: that.props.dataset_info.dataSet,
            pageName: "pinboard",
            property: item.parameters.category,
            propertyDisp: property_disp,
            selectedMetric: item.parameters.selectedMetric,
            selectedMetricDisp: selectedMetricDisp,
            breakup: item.parameters.breakUp,
            SelectedBreakUpDisp: selectedBreakUpDisp,
            include: item.parameters.include,
            includeDisp: includeDisp,
            exclude: item.parameters.exclude,
            excludeDisp: excludeDisp,
            period: item.parameters.period,
            TimeType: TimeType,
            startDate: startDate,
            endDate: endDate,
            Metric: that.props.metricGlobal,
            metricFunction: that.props.metricFunction,
            chartCat: item.parameters.chartCat,
            chartType: item.parameters.chartType,
            transpose: item.parameters.transpose,
            crosstab_flag: item.parameters.multiDim,
            kpiMonitoring: item.parameters.kpiMonitoring,
            sortOrder: item.parameters.sortOrder,
            limit: item.parameters.limit,
            editCompModal: true,
            itemDetails: item,
            dashboardID: that.state.dashboard_id
        }
        that.setState({ ...that.state, editComponentFilterProps: filterProps })
        setTimeout(()=>{
            jQuery('#editDashboardComponent').modal('toggle');
        },1000)
    }
    prepareDashboardComponents(dashboardComponents, thatObj) {
        dashboardComponents = dashboardComponents && dashboardComponents != -1 && dashboardComponents.length > 0 ? dashboardComponents : [];
        let metaData = dashboardComponents[0] ? JSON.parse(dashboardComponents[0].meta_data) : {};

        let calendar = null, temp_exclude = null, temp_include = null, temp_breakup_value = null, propertyValue = null, above_charts = null, fullscreen = null, defaultConfig = null, configInformation = null;

        propertyValue = thatObj.props.property && thatObj.props.property != 'null' ? thatObj.props.property : null
        temp_breakup_value = thatObj.props.breakup;
        var breakupArray = thatObj.props.dataset_info.breakupDisp ? thatObj.props.dataset_info.breakupDisp : [];

        var arrayComponents = dashboardComponents.map(function (item, i) {
            temp_breakup_value = thatObj.props.breakup;
            temp_include = thatObj.state.include

            if (typeof item.parameters !== 'object' && IsJsonString(item.parameters)) {
                item.parameters = jQuery.parseJSON(item.parameters);
                item.parameters = typeof item.parameters !== 'object' && IsJsonString(item.parameters)
                    ? jQuery.parseJSON(item.parameters)
                    : item.parameters;
            }

            let actualMeta = {};
            metaData.map(function (array, index) {
                if (array.id == item.iddashboardConfiguration) {
                    actualMeta = array;
                }
            })

            var index = item.iddashboardConfiguration;
            var componentValue = null;

            var startDate = null
            var endDate = null
            var dataPoint = item.parameters?.dataPointConfig
            var yAxis = item.parameters?.yAxisFlag
            var item_type = null

            if (this.props.dashboardConfigDates) {
                var startDate = this.props.dashboardConfigDates.startDate ? this.props.dashboardConfigDates.startDate : null;
                var endDate = this.props.dashboardConfigDates.endDate ? this.props.dashboardConfigDates.endDate : null;
                calendar = false;
            }
            dynamicStartDate = null, dynamicEndDate = null
            var actualStartDate = null, actualEndDate = null
            if (!startDate || !endDate) {
                // var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
                var format = /[{}]+/;   // Pattern to check
                if (item.information) {
                    let parsedInfo = JSON.parse(item.information)
                    if (parsedInfo.startDate && parsedInfo.endDate) {
                        actualStartDate = parsedInfo.startDate
                        actualEndDate = parsedInfo.endDate
                        item_type = 'dynamic'
                    }
                }
                if (!actualStartDate || !actualEndDate) {
                    actualStartDate = item.parameters.startDate
                    actualEndDate = item.parameters.endDate
                }
                const startDateCase1 = format.test(actualStartDate);  // Check startDate is in json format or contains {}
                const startDateCase2 = typeof actualStartDate === 'object';   // Check if startDate is onject
                const endDateCase1 = format.test(actualEndDate);  // Check endDate is in json format or contains {}
                const endDateCase2 = typeof actualEndDate === 'object';   // Check if endDate is onject
                // if(IsJsonString(item.parameters.startDate.replace(/'/g,'"'))){
                let tempuserDBsetting = this.props.dataSet.userDBSetting ? this.props.dataSet.userDBSetting[0] : null;
                if (window.location.pathname.split('/')[1] == "globaldashboards") {
                    tempuserDBsetting = this.props.allDBSettingsData[item.toolId][0];
                }

                if (startDateCase1 || startDateCase2) {
                    actualStartDate = startDateCase2 ? actualStartDate : JSON.parse(actualStartDate.replace(/'/g, '"'));
                    let tempDate = actualStartDate.date_method == "endDate" ? maxDateCalendar : minDateCalendar;
                    if (actualStartDate.date_format && ['mtd', 'ytd', 'lq'].indexOf(actualStartDate.date_format.toLowerCase()) > -1) {
                        if (actualStartDate.date_format.toLowerCase() == "mtd") {
                            var startDate = dynamicStartDate = moment(tempDate).startOf('Month').format('YYYY-MM-DD');
                        } else if (actualStartDate.date_format.toLowerCase() == "ytd") {
                            tempDate = tempuserDBsetting.FYMonthStart != "0" ? moment(tempDate).subtract(tempuserDBsetting.FYMonthStart - 1, 'M').format('YYYY-MM-DD') : tempDate;

                            var startDate = dynamicStartDate = tempuserDBsetting.FYMonthStart != "0" ? moment(tempDate).startOf('year').add(tempuserDBsetting.FYMonthStart - 1, 'M').format('YYYY-MM-DD') : moment(tempDate).startOf('year').format('YYYY-MM-DD');
                        } else if (actualStartDate.date_format.toLowerCase() == "lq") {
                            if (moment(tempDate).endOf('quarter').format('YYYY-MM-DD') == moment(tempDate).format('YYYY-MM-DD')) {
                                var startDate = dynamicStartDate = moment(tempDate).startOf('quarter').format('YYYY-MM-DD');
                            }
                            else {
                                let quarterNumber = 4 / (moment(tempDate).quarter() - 1) != Infinity ? moment(tempDate).quarter() - 1 : 4;
                                var startDate = dynamicStartDate = moment(tempDate).subtract(3, 'M').quarter(quarterNumber).startOf('quarter').format('YYYY-MM-DD');
                            }
                        }
                    }
                    else var startDate = dynamicStartDate = moment(tempDate).subtract(actualStartDate.count, actualStartDate.date_format).startOf(actualStartDate.date_format).format('YYYY-MM-DD');
                    item_type = 'dynamic'
                } else {
                    var startDate = actualStartDate;
                    item_type = 'static'
                }

                // if(IsJsonString(item.parameters.endDate.replace(/'/g,'"'))){
                if (endDateCase1 || endDateCase2) {
                    actualEndDate = endDateCase2 ? actualEndDate : JSON.parse(actualEndDate.replace(/'/g, '"'));
                    let tempDate = actualEndDate.date_method == "endDate" ? maxDateCalendar : minDateCalendar;
                    if (actualStartDate.date_format && ['mtd', 'ytd', 'lq'].indexOf(actualStartDate.date_format.toLowerCase()) > -1) {
                        if (actualStartDate.date_format.toLowerCase() == "lq") {
                            if (moment(tempDate).endOf('quarter').format('YYYY-MM-DD') == moment(tempDate).format('YYYY-MM-DD')) {
                                var endDate = dynamicEndDate = moment(tempDate).format('YYYY-MM-DD');
                            } else {
                                let quarterNumber = 4 / (moment(tempDate).quarter() - 1) != Infinity ? moment(tempDate).quarter() - 1 : 4;
                                var endDate = dynamicEndDate = moment(tempDate).subtract(3, 'M').quarter(quarterNumber).endOf('quarter').format('YYYY-MM-DD');
                            }
                        }
                        else var endDate = dynamicEndDate = moment(tempDate).format('YYYY-MM-DD');
                    }
                    else var endDate = dynamicEndDate = moment(tempDate).subtract(actualEndDate.count, actualEndDate.date_format).format('YYYY-MM-DD');
                } else var endDate = actualEndDate;

                calendar = true;
            }
            var columnWidth = item.parameters.ColumnWidth ? item.parameters.ColumnWidth : null;

            var breakUp = item.parameters.breakUp;
            var exclude = item.parameters.exclude ? item.parameters.exclude : this.state.exclude;
            var include = item.parameters.include ? item.parameters.include : this.state.include

            if (exclude)
                exclude += temp_exclude ? "," + temp_exclude : "";
            else exclude = temp_exclude;
            if (include && include.length > 0) {
                if (include === temp_include) {
                    include = include
                } else {
                    include += temp_include ? "," + temp_include : "";
                }
            }
            else include = temp_include;
            // if (breakUp)
            //     breakUp += "," + temp_breakup_value;
            // else breakUp = temp_breakup_value;

            var breakupText = item.parameters.breakupText ? item.parameters.breakupText : "";
            var includeText = item.parameters.includeText ? item.parameters.includeText : "";
            var excludeText = item.parameters.excludeText ? item.parameters.excludeText : "";

            var appendBreakup = '';
            var appendInclude = '';
            var appendExclude = '';

            if (breakupText)
                appendBreakup = ' and ';
            if (includeText)
                appendInclude = ' and ';
            if (breakupText)
                appendExclude = ' and ';

            var includeArray = this.state.includeArray ? this.state.includeArray : [];
            var excludeArray = this.state.excludeArray ? this.state.excludeArray : [];

            // var breakupArray = this.state.breakup;
            if (item.parameters.breakupHierachy && this.state.allHierarchyValues) {
                if (this.state.allHierarchyValues['property']) {
                    temp_breakup_value = this.state.allHierarchyValues['property'][item.parameters.breakupHierachy];
                    breakupArray = [this.state.allHierarchyValues['propertyDisp'][item.parameters.breakupHierachy]];
                    let includeArray = include ? include.split(",") : [];
                    if (this.state.breakupvalue) {
                        include = includeArray.join();
                    } else {
                        include = includeArray.length > 1 ? includeArray.shift() : null;
                        include = includeArray.join();
                    }
                }
            }

            var length_breakup = breakupArray ? breakupArray.length : 0;
            var length_include = includeArray ? includeArray.length : 0;
            var length_exclude = excludeArray ? excludeArray.length : 0;

            breakupText = breakupText ? breakupText.replace(" and", ",") : "";
            includeText = includeText ? includeText.replace(" and", ",") : "";
            excludeText = excludeText ? excludeText.replace(" and", ",") : "";

            if (temp_breakup_value) {

                if (breakUp)
                    breakUp += "," + temp_breakup_value;
                else breakUp = temp_breakup_value;
                breakupText = breakupText ? breakupText.replace(" and", ",") : "";
                var length_breakup = this.state.breakup ? this.state.breakup.length : null;
                var append = '';
                if (breakupText)
                    append = ' and ';

                breakupArray && breakupArray.map(function (element, index) {
                    if (breakupText && length_breakup == index + 1)
                        breakupText += append + element.label;
                    else breakupText += breakupText ? ", " + element.label : element.label;
                });
            }

            var append = '';
            if (includeText)
                append = ' and ';

            includeArray && includeArray.map(function (element, index) {
                if (includeText && length_include == index + 1)
                    includeText += append + element.label;
                else includeText += includeText ? ", " + element.label : element.label;
            });

            var append = '';
            if (excludeText)
                append = ' and ';

            excludeArray && excludeArray.map(function (element, index) {
                if (excludeText && length_exclude == index + 1)
                    excludeText += append + element.label;
                else excludeText += excludeText ? ", " + element.label : element.label;
            });

            if (item.componentType == 'Summary') {
                var url = "/summary?startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate) + "&property=" + encodeURIComponent(item.parameters.category) + "&breakup=" + encodeURIComponent(breakUp) + "&include=" + encodeURIComponent(include) + "&exclude=" + encodeURIComponent(exclude) + "&selectedMetric=" + encodeURIComponent(item.parameters.selectedMetric) + "&toolId=" + encodeURIComponent(item.toolId);
            } else if (item.componentType == 'Chart') {
                var url = "/chart/chartData?startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate) + "&property=" + encodeURIComponent(item.parameters.category) + "&breakup=" + encodeURIComponent(breakUp) + "&include=" + encodeURIComponent(include) + "&exclude=" + encodeURIComponent(exclude) + "&metric=" + encodeURIComponent(item.parameters.metric) + "&chartType=" + encodeURIComponent(item.parameters.chartType) + "&chartStyle=" + encodeURIComponent(item.parameters.chartCat) + "&analysis=" + encodeURIComponent(item.parameters.analysis) + "&clusterCount=" + encodeURIComponent(item.parameters.clusterCount) + "&drill=" + encodeURIComponent(item.parameters.drill) + "&chartCat=" + encodeURIComponent(item.parameters.chartCat) + "&sortOrder=" + encodeURIComponent(item.parameters.sortOrder) + "&limit=" + encodeURIComponent(item.parameters.limit) + "&toolId=" + encodeURIComponent(item.toolId) + "&compare=" + encodeURIComponent(item.parameters.compare) + "&metricRange=" + encodeURIComponent(item.parameters.metricRange);
            } else if (item.componentType == 'Report') {
                var url = "/report?startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate) + "&property=" + encodeURIComponent(item.parameters.category) + "&breakup=" + encodeURIComponent(breakUp) + "&include=" + encodeURIComponent(include) + "&exclude=" + encodeURIComponent(exclude) + "&selectedMetric=" + encodeURIComponent(item.parameters.selectedMetric) + "&period=" + encodeURIComponent(item.parameters.period) + "&insightType=" + encodeURIComponent(item.parameters.insightType) + "&insightMetric=" + encodeURIComponent(item.parameters.insightMetric) + "&metricRange=" + encodeURIComponent(item.parameters.metricRange) + "&sortOrder=" + encodeURIComponent(item.parameters.sortOrder) + "&limit=" + encodeURIComponent(item.parameters.limit) + "&toolId=" + encodeURIComponent(item.toolId) + "&transpose=" + encodeURIComponent(item.parameters.transpose) + "&kpiMonitoring=" + encodeURIComponent(item.parameters.kpiMonitoring ? item.parameters.kpiMonitoring : false) +"&kpiColumnConfig=" + encodeURIComponent(item.parameters.kpiColumnConfig ? item.parameters.kpiColumnConfig : '') + "&multiDim=" + encodeURIComponent(item.parameters.multiDim) + "&shortenHandle=true";
                fullscreen = <a href="#" onClick={this.enterFullScreen.bind(this, index)} className="float-right ml-1" data-toggle="tooltip" title="Full screen" data-placement="bottom"><i className='fa fa-arrows-alt'></i></a>
            }

            let selectMetricValue = item.parameters.metric ? item.parameters.metric : item.parameters.selectedMetric;
            let newMetricArray = this.props.metricGlobal;
            if (window.location.pathname.split('/')[1] == "globaldashboards")
                newMetricArray = this.props.allMetric[item.toolId];

            var selectedMetricDisp = metricDataToDisp(newMetricArray, this.props.metricFunction, selectMetricValue);

            var category_to_use = item.parameters.category;
            var propertyText_to_use = item.parameters.propertyText;
            if (window.location.pathname.split('/')[1] != "globaldashboards" && propertyValue) {
                category_to_use = propertyValue;
                propertyText_to_use = propertyValue;
            }
            var category_to_use_array = category_to_use ? category_to_use.split(",") : null;
            var that = this, property_disp = []
            category_to_use_array && category_to_use_array.map(function (innerCategory) {
                if (innerCategory && innerCategory != 'null' && innerCategory != 'empty') {
                    that.props.allProperty && Object.values(that.props.allProperty).map((innerData) => {
                        if (innerData.value.toLowerCase() == innerCategory.toLowerCase())
                            property_disp.push({ "label": innerData.label, "value": innerCategory });
                    })
                } else if (['null', null, 'empty'].indexOf(innerCategory) > -1)
                    property_disp.push({ "label": "Total", "value": innerCategory });
            })

            var selectedBreakUpDisp = getBreakupDisp(item.parameters.breakUp, that.state.dataSet.alfred.property)
            var includeDisp = getBreakupDisp(item.parameters.include, that.state.dataSet.alfred.property)
            var excludeDisp = getBreakupDisp(item.parameters.exclude, that.state.dataSet.alfred.property)

            let exportButton = null, ExportComponentVar = null;
            let modalConfig = {
                "exportSettings": {
                    "id": `exportSettings_${index}`, "form_name": "exportSettings", "title": "Export", "body": null, "buttonType": "submit", "button_name": "Export", "display": true
                },
                "editComponent": {
                    "id": 'editDashboardComponent', "title": "Edit Component", "display": true, 'noFooter': true, 'formKey': `editComponent_${Math.floor(Math.random() * 10)}`, bodyStyle: true
                }
            }

            if (item.componentType == 'Chart' || item.componentType == 'Report' || item.componentType == 'Summary') {
                exportButton = <a className="dropdown-item" data-bs-toggle="modal" href={`#exportSettings_${index}`} id={`exportSettingHandleButton_${index}`}>Export</a>
                // Export Options
                var exportOptions;
                if (item.componentType == 'Summary') {
                    exportOptions = [{ "name": "Excel", "value": "xls" }, { "name": "CSV", "value": "csv" }]
                } else {
                    exportOptions = item.componentType == 'Report' ? [{ "name": "Excel", "value": "excel" }, { "name": "CSV", "value": "csv", }] : [{ "name": "PNG", "value": "image/png" }, { "name": "JPEG", "value": "image/jpeg" }]
                }

                let formData = {
                    "exportFileName": { "name": `exportFileName_${index}`, "label": "File Name", "type": "text", requiredFlag: true },
                    "exportType": {
                        "name": `exportType_${index}`, "label": "Export Type", "type": "dropdown", "options": exportOptions, requiredFlag: true
                    }
                }

                var Form_Data = <Form label_array={formData} />;

                modalConfig['exportSettings']['body'] = Form_Data;
                modalConfig['exportSettings']['formKey'] = `export_${Math.floor(Math.random() * 10)}`;

                ExportComponentVar = item.componentType == 'Summary' ? (<ModalComponent modalConfig={modalConfig["exportSettings"]} formSubmit={(e) => this.downloadHandleActionSummary(e, index)} />) : (<ModalComponent modalConfig={modalConfig["exportSettings"]} formSubmit={(e) => downloadHandleAction(e, item.componentType, toExcel, ExportToCsv, index, true)} />)

                modalConfig['editComponent']['body'] = Object.keys(this.state.editComponentFilterProps).length > 0
                    ? <FilterComponent {...this.state.editComponentFilterProps} getComponentsAPI={this.get_components} />
                    : null
                editComponentModal = (<ModalComponent modalConfig={modalConfig["editComponent"]} />)
            }

            var label_shortened = item.label && item.label.length > 80 ? item.label.substring(0, 80) + "..." : item.label;

            var above_charts = <p className="list-group-item d-sm-flex align-items-center justify-content-between borderless mg-b-0">
                <span data-toggle="tooltip" id={"title_charts_" + index} title={item.label} data-placement="bottom">{label_shortened}</span>
                <span id={`title_charts_value_${index}`} style={{ display: "none", width: '80%' }}>
                    <input type='text' className='form-control' style={{ width: '100%' }} id={`chart_title_${index}`} defaultValue={item.label} />
                    <div style={{ marginTop: '3px' }}>
                        <button className='btn-sm btn btn-white' id={`save_button_${index}`} onClick={this.handle_save_dashboard.bind(this, index)}> Save </button>
                        <button style={{ marginLeft: '5px' }} className='btn-sm btn btn-white' onClick={this.handle_edit_chart_title.bind(this, index, "cancel")}>Cancel</button>
                    </div>
                </span>
                <div className="d-md-flex">
                    <div className="dropdown-file">
                        <a href="" className="dropdown dropdown-link" data-bs-toggle="dropdown"><i className=" desc-btn fas fa-ellipsis-v"></i></a>
                        <div className="dropdown-menu dropdown-menu-end">
                            {checkIfFeatureApplicable('Open In New Tab Dashboard') ? <a className="dropdown-item" target="_blank" onClick={()=>this.setKpiColumnConfig(item,url)}>Open In New Tab</a> : ''}
                            <a className="dropdown-item" onClick={this.information.bind(this, index, item.componentType)}>Toggle information</a>
                            {checkIfFeatureApplicable('Edit Dashboard Component Name') ? <a className="dropdown-item" onClick={() => this.handleEditComponent(item, startDate, endDate, property_disp, includeDisp, excludeDisp, selectedMetricDisp, selectedBreakUpDisp)}>Edit Component</a> : ''}
                            {checkIfFeatureApplicable('Edit Dashboard Component Name') ? <a className="dropdown-item" onClick={this.handle_edit_chart_title.bind(this, index, "edit")}>Edit Name</a> : ''}
                            {checkIfFeatureApplicable('Delete Dashboard Component') ? <a className="dropdown-item" onClick={this.deletePin.bind(this, item.iddashboardConfiguration)}>Delete</a> : ''}
                            {checkIfFeatureApplicable('Download') ? exportButton : ''}
                        </div>
                    </div>
                </div>
            </p>;

            let chartCat = item.parameters.chartCat ? item.parameters.chartCat.toLowerCase() : ''

            var status = validationInput(category_to_use ? category_to_use : "", item.parameters.metric, item.parameters.chartType ? item.parameters.chartType : "", chartCat, "status");

            let itemDashboardConfig = typeof item.dashboard_config == "string" ? JSON.parse(item.dashboard_config) : item.dashboard_config;
            defaultConfig = status && typeof status.style == "string" ? JSON.parse(status.style) : status.style;
            defaultConfig = defaultConfig && typeof defaultConfig == "object" ? defaultConfig : this.props.dashboardConfig;
            defaultConfig['information'] = itemDashboardConfig ? itemDashboardConfig['information'] : false;
            defaultConfig['colorArray'] = typeof this.props.dashboardConfig['colorArray'] == "string" ? JSON.parse(this.props.dashboardConfig['colorArray']) : this.props.dashboardConfig['colorArray'];
            defaultConfig['labelOverlap'] = item.parameters.dataLabelOverlap;

            if (window.location.pathname.split('/')[1] == "globaldashboards") {
                defaultConfig['colorArray'] = this.props.allDBSettingsData[item.toolId] ? JSON.parse(this.props.allDBSettingsData[item.toolId][0].color) : defaultConfig['colorArray'];
            } else defaultConfig['colorArray'] = defaultConfig['colorArray'] && defaultConfig['colorArray'].length > 0 ? defaultConfig['colorArray'] : (this.props.dataSet.userDBSetting ? JSON.parse(this.props.dataSet.userDBSetting[0].color) : []);

            if (item.componentType == 'Summary') {
                var above_summary = <div >
                    <a href="#" style={{ overflow: 'auto' }} onClick={this.deletePin.bind(this, item.iddashboardConfiguration)}><i className='float-right ml-1 fa fa-times' data-toggle="tooltip" title="Delete pin" data-placement="bottom"></i></a>
                    <a href={url} target="_blank"><i className='float-right ml-1 fa fa-external-link-alt' data-toggle="tooltip" title="Go to page!" data-placement="bottom"></i></a>
                </div>;
                // above_summary = isMultiSummaryComponent ? above_charts : above_summary;
                above_summary = above_charts;

                componentValue = <div className="card grid-stack-item-content">
                    {/* {above_summary} */}
                    <SummaryData
                        authData={this.props.authData}
                        startDate={startDate}
                        chartTitle={above_summary}
                        endDate={endDate}
                        category={category_to_use}
                        categoryValue={item.parameters.categoryValue}
                        metric={item.parameters.metric}
                        breakUp={breakUp}
                        include={include && include !== "undefined" ? include : ""}
                        exclude={exclude && exclude !== "undefined" ? exclude : ""}
                        selectedMetric={item.parameters.selectedMetric}
                        periodComparison={item.parameters.periodComparison}
                        metricRange={item.parameters.metricRange}
                        outputType={''}
                        selectedMetricDisp={selectedMetricDisp}
                        metricText={item.parameters.metricText}
                        propertyText={propertyText_to_use}
                        breakupText={breakupText}
                        recommendation={true}
                        index={index}
                        isDashboard={item.parameters.isDashboard}
                        dashboard={true}
                        deletePin={this.deletePin}
                        dashboard_config={defaultConfig}
                        toolId={item.toolId}
                        mainMetric={newMetricArray}
                        ExportComponentVar={ExportComponentVar}
                        openInNewTabURL={url}
                        // drillHandle={this.drillHandle}
                        drillHandle={drillHandleFunction}
                        report_type={item_type}
                        handleEditComponent={this.handleEditComponent}
                        itemDetails={item}
                        property_disp={property_disp}
                        includeDisp={includeDisp}
                        excludeDisp={excludeDisp}
                        selectedBreakUpDisp={selectedBreakUpDisp}
                        globalFilters={this.props.globalFilters}
                        sortMetric={this.props.sortMetric}
                        cagrPoint={this.props.cagrPoint}
                        removeGlobalFilter={item.parameters.removeGlobalFilter?item.parameters.removeGlobalFilter:this.props.removeGlobalFilter}
                                                prevStartDate={item?.parameters?.prevStartDate}
                        prevEndDate={item?.parameters?.prevEndDate}


                    />
                </div>;
            } else if (item.componentType == 'Chart') {


                var chartDispStyle = "nontimeseries";
                var timeseries_chart = ["Line", "Column", "Column Stacked", "Column Stacked Normal", "Area", "Bullet", "Columnline", "Barline"];
                if (item.parameters.chartType != "Aggregate" && item.parameters.chartType != "null" && timeseries_chart.indexOf(item.parameters.chartCat) > -1) {
                    chartDispStyle = "timeseries";
                }

                // configInformation = defaultConfig ? defaultConfig.information : false;
                // configInformation = configInformation === true ? 'show' : 'hide';
                let period = item.parameters.chartType == "Aggregate" ? null : item.parameters.chartType
                componentValue = <div className="card grid-stack-item-content">
                    {/* {above_charts} */}
                    {status.valid == true ? <Chart
                        dataLabelConfig={dataPoint}
                        yAxis={yAxis}
                        dataSet={this.props.dataSet}
                        authData={this.props.authData}
                        chartTitle={above_charts}
                        startDate={startDate}
                        endDate={endDate}
                        category={category_to_use}
                        categoryValue={item.parameters.categoryValue}
                        metric={item.parameters.metric}
                        breakUp={breakUp}
                        include={include}
                        exclude={exclude}
                        chartType={period}
                        period={period}
                        chartDispStyle={chartDispStyle}
                        analysis={item.parameters.analysis}
                        regressionLine={item.parameters.regressionLine}
                        clusterCount={item.parameters.clusterCount}
                        initial={item.parameters.initial}
                        drill={item.parameters.drill}
                        // drillHandle={item.parameters.drillHandle}
                        drillHandle={drillHandleFunction}
                        chartDisp={item.parameters.chartCat}
                        chartCat={status.chartDisp ? status.chartDisp : item.parameters.chartCat}
                        sortOrder={item.parameters.sortOrder}
                        limit={item.parameters.limit}
                        date={item.parameters.date}
                        point={item.parameters.point}
                        timeHandle={item.parameters.timeHandle}
                        insightHandle={item.parameters.insightHandle}
                        downloadChart={item.parameters.downloadChart}
                        metricText={item.parameters.metricText}
                        propertyText={propertyText_to_use}
                        breakupText={breakupText}
                        summary={false}
                        index={index}
                        compare={item.parameters.compare}
                        compareRank={item.parameters.compareRank}
                        selectedParam={item.parameters.selectedParam}
                        // calendarStatus={calendar}
                        calendarStatus={true}
                        handleChange={item.parameters.handleChange}
                        selectedMetricDisp={selectedMetricDisp}
                        metricRange={item.parameters.metricRange}
                        dashboard={true}
                        dashboard_config={defaultConfig}
                        toolId={item.toolId}
                        mainMetric={newMetricArray}
                        ExportComponentVar={ExportComponentVar}
                        waterfallPointWidth={true}
                        report_type={item_type}
                        itemDetails={item}
                        globalFilters={this.props.globalFilters}
                        removeGlobalFilter={item.parameters.removeGlobalFilter ? item.parameters.removeGlobalFilter : this.props.removeGlobalFilter}
                                                prevStartDate={item?.parameters?.prevStartDate}
                        prevEndDate={item?.parameters?.prevEndDate}


                    /> : <div className='pd-b-0'><NoDataFound data={status.message} /></div>}
                </div>
            } else if (item.componentType == 'Report') {


                // var propertyText_to_use_copy = propertyText_to_use.split(",");

                // var property_disp = category_to_use_array.map(function (innerData, index) {
                //     var property_array_index = propertyText_to_use_copy[index] ? propertyText_to_use_copy[index].trim() : propertyText_to_use_copy[index];
                //     if (property_array_index && property_array_index.indexOf(" and") > 1) {
                //         property_array_index = property_array_index.split(" and");
                //         propertyText_to_use_copy.push(property_array_index[1]);
                //         property_array_index = property_array_index[0];
                //     }
                //     return { "label": property_array_index, "value": innerData };
                // })

                // var property_disp=[{"label":propertyText_to_use_copy[0],'value':category_to_use}];
                let dashboardLayout = JSON.parse(dashboardComponents[0].information).PAGE_LAYOUT;
                componentValue = <div className="card grid-stack-item-content" id={"table" + index + '1'}>
                    <TableData
                        authData={this.props.authData}
                        tableTitle={above_charts}
                        startDate={startDate}
                        endDate={endDate}
                        columnWidth={columnWidth}
                        category={category_to_use}
                        selectedMetric={item.parameters.selectedMetric}
                        breakUp={breakUp}
                        include={include}
                        dashboardLayout={dashboardLayout}
                        exclude={exclude}
                        metrics={metricGlobal}
                        chartType={'report'}
                        chartCat={'report'}
                        drill={item.parameters.drill}
                        drillHandle={drillHandleFunction}
                        question={null}
                        questionId={null}
                        questionData={null}
                        sortOrder={item.parameters.sortOrder}
                        limit={item.parameters.limit}
                        insightType={item.parameters.insightType}
                        insightMetric={item.parameters.insightMetric}
                        insightPoint={item.parameters.insightPoint}
                        handleChange={null}
                        index={index + '1'}
                        // calendarStatus={calendar}
                        calendarStatus={true}
                        selectedMetricDisp={selectedMetricDisp}
                        metricRange={item.parameters.metricRange}
                        metricText={item.parameters.metricText}
                        propertyText={propertyText_to_use}
                        propertyDisp={property_disp}
                        breakupText={breakupText}
                        includeText={includeText}
                        excludeText={excludeText}
                        period={item.parameters.period}
                        transpose={item.parameters.transpose}
                        multiDim={item.parameters.multiDim}
                        multiDimGroup={item.parameters.multiDimGroup}
                        shortenHandle={true}
                        dashboard={true}
                        dashboard_config={defaultConfig}
                        toolId={item.toolId}
                        mainMetric={newMetricArray}
                        ExportComponentVar={ExportComponentVar}
                        kpiMonitoring={item.parameters.kpiMonitoring}
                        report_type={item_type}
                        kpiColumnConfig={item.parameters.kpiColumnConfig}
                        itemDetails={item}
                        globalFilters={this.props.globalFilters}
                        sortMetric={item?.parameters?.sortMetric}
                        cagrPoint={item?.parameters?.cagrPoint}
                        removeGlobalFilter={item.parameters?.removeGlobalFilter?item.parameters?.removeGlobalFilter:this.props.removeGlobalFilter}
                        prevStartDate={item?.parameters?.prevStartDate}
                        prevEndDate={item?.parameters?.prevEndDate}
                    />
                </div>
                count_reports.push(index)
            }
            return (<div className="grid-stack-item" data-gs-width={actualMeta.width} data-gs-height={actualMeta.height} data-gs-x={actualMeta.x} data-gs-y={actualMeta.y} data-gs-id={actualMeta.id} key={"report" + actualMeta.id}>{componentValue}</div>);
        }.bind(this));
        return { "gridElement": <div className={`grid-stack`}>{arrayComponents}</div>, layout: metaData };
    }
    dashboardreindex(id) {
        this.setState({ ...this.state, selectedFilters: {}, currentPage: 1 })
        jQuery('[data-toggle="tooltip"]').tooltip("hide")
        let finalId = null, finalType = null;
        let checkId = this.props.dashboardUIType == 'tabs' ? 'index' : 'dashboardId'
        this.dashboardTabArray.map(function (innerData) {
            if (innerData[checkId] == id) {
                finalId = innerData.dashboardId
                finalType = innerData.type
            }
        })
        this.dashboard_change_handle(finalId, finalType);
    }
    handleModalEvent = (modalEventName) => {
        filtersChanged = modalEventName ? true : false
        this.setState({ modalName: modalEventName })
    }
    dashboardFilterCancelHandler() {
        this.setState({
            dimensionFilter: this.props.dimensionFilter
        })
    }
    handlePinboardEvent = (pinboardEvent) => {
        this.setState({ pinboardEventName: pinboardEvent })
    }
    handleDashboardFilters(selectedValue, dimensionVal) {
        let that = this;
        let selectedFilters = that.state.selectedFilters
        let propsSelectedFilterValues = that.props.selectedFilterValues != undefined && that.props.selectedFilterValues != null ? that.props.selectedFilterValues : {}
        let filterValue = dashboardFilterValues ? dashboardFilterValues : that.state.include
        let tempObject = Object.values(selectedFilters).length > 0
            ? JSON.parse(JSON.stringify(selectedFilters))
            : {} 

        if (dashboard_filters !== undefined && dashboard_filters !== null) {
            Object.keys(dashboard_filters).map(function (innerData) {
                if (dimensionVal === innerData)
                    tempObject[innerData] = selectedValue
            })
            let tempFilter = selectedValue.map(function (innerData) {
                return innerData.value;
            });
            if (filterValue === null || filterValue === 'empty') {
                filterValue = tempFilter.join()
            } else if (tempFilter && tempFilter.length > (selectedFilters[dimensionVal] && selectedFilters[dimensionVal].length)) {
                tempObject[dimensionVal].filter(el => {
                    if (selectedFilters[dimensionVal].includes(el) === false) {
                        filterValue = filterValue.concat(',', el.value)
                    }
                })
            } else if (tempFilter && tempFilter.length < (selectedFilters[dimensionVal] && selectedFilters[dimensionVal].length)) {
                selectedFilters[dimensionVal].filter(el => {
                    if (tempObject[dimensionVal].includes(el) === false) {
                        let filterValueArray = filterValue.split(',')
                        let index_to_remove = filterValueArray.indexOf(el.value)
                        filterValueArray.splice(index_to_remove, 1)
                        filterValue = filterValueArray.join()
                    }
                })
            } else if (selectedFilters && Object.values(selectedFilters).length > 0 && Object.keys(selectedFilters).indexOf(dimensionVal) === -1) {
                filterValue = filterValue.concat(',', tempFilter.join())
            } else if (tempFilter && tempFilter.length > (propsSelectedFilterValues[dimensionVal] && propsSelectedFilterValues[dimensionVal].length)) {
                tempObject[dimensionVal].filter(el => {
                    if (propsSelectedFilterValues[dimensionVal].includes(el) === false) {
                        filterValue = filterValue.concat(',', el.value)
                    }
                })
            } else if (tempFilter && tempFilter.length < (propsSelectedFilterValues[dimensionVal] && propsSelectedFilterValues[dimensionVal].length)) {
                propsSelectedFilterValues[dimensionVal].filter(el => {
                    if (tempObject[dimensionVal].includes(el) === false) {
                        let filterValueArray = filterValue.split(',')
                        let index_to_remove = filterValueArray.indexOf(el.value)
                        filterValueArray.splice(index_to_remove, 1)
                        filterValue = filterValueArray.join()
                    }
                })
            } else if (propsSelectedFilterValues && Object.values(propsSelectedFilterValues).length > 0 && Object.keys(propsSelectedFilterValues).indexOf(dimensionVal) === -1) {
                filterValue = filterValue.concat(',', tempFilter.join())
            }
            if (tempObject[dimensionVal].length === 0) {
                delete tempObject[dimensionVal]
            }
            filterValue = filterValue && filterValue !== "" ? filterValue : 'empty';
            dashboardFilterValues = filterValue
            filtersChanged = true
        }
        that.setState({ ...that.state, selectedFilters: tempObject })
    }
    handleApplyFilters = () => {
        filtersAppliedFlag = true
        filtersChanged = false
        if (dashboardFilterValues === null) {
            alert("No changes detected to existing filters to Apply!");
        } else {
            let that = this, response = {};
            if (dashboardFilterValues !== "empty") {
                response = {
                    include: JSON.stringify(getBreakupDisp(dashboardFilterValues, that.state.dataSet.alfred.property))
                }
            } else {
                response = {
                    include: []
                }
            }
            let new_props = { include: dashboardFilterValues }
            if (new_props.location && window.location.pathname === '/summary' && new_props.location.pathname !== window.location.pathname) {
                new_props.property = 'null'
            }
            let finalObj = handleParamsToSet(response, new_props, that)
            that.props.set_disp_objects({ ...finalObj, 'selectedFilterValues': that.state.selectedFilters, 'initialDataApiFlag': true })
            that.setState({ include: dashboardFilterValues, includeArray: response.include.length > 0 ? JSON.parse(response.include) : response.include })
            // document.getElementById('apply_filter').setAttribute('style', 'background-color:green !important');
            document.getElementById('apply_filter').innerHTML = "Filters Applied";
            dashboardFilterValues = null
            setTimeout(()=>{
                document.getElementById('apply_filter').innerHTML = "Apply Filters";
            },700)
        }
    }
    displayFilters = (status) => {
        filtersChanged = true

        if (status != 'Hide') {
            this.setState({ filtersVisible: !this.state.filtersVisible })
        } else {
            this.setState({ filtersVisible: !this.state.filtersVisible, selectedFilters: this.state.selectedFilterValues ? this.state.selectedFilterValues : [] })
        }
    }
    reHeightGrid() {
        const gridEl = document.querySelector('.grid-stack');
        if (!gridEl) return;
        const gridItems = gridEl.querySelectorAll('.grid-stack-item');

        let maxBottom = 0;

        gridItems.forEach(item => {
            const y = parseInt(item.getAttribute('data-gs-y'), 10);
            const height = parseInt(item.getAttribute('data-gs-height'), 10);
            const bottom = y + height;
            if (bottom > maxBottom) {
                maxBottom = bottom;
            }
        });

        const rowHeight = 80;
        const newHeight = maxBottom * rowHeight;

        // Update container height
        gridEl.style.height = `${newHeight}px`;
    }
    paginate = (pageNumber) => {
        this.props.setInsightFunction({ "point": null, "insight": false });
        this.setState({ ...this.state, currentPage: pageNumber })
        filtersAppliedFlag = true
    }
    nextPagePaginate = (pageNumber) => {
        this.props.setInsightFunction({"point": null, "insight": false});
        this.setState({ ...this.state, currentPage: pageNumber + 1 })
        filtersAppliedFlag = true
    }
    previousPagePaginate = (pageNumber) => {
        this.props.setInsightFunction({"point": null, "insight": false});
        this.setState({ ...this.state, currentPage: pageNumber - 1 })
        filtersAppliedFlag = true
    }
    globalFilterHandler(e) {
        jQuery('#globalFilterModal').modal("show")
    }
    globalFilterInputHandler(value) {
        filtersChanged = true
        this.setState({
            globalFilterValues: value == null ? [] : value
        })
    }
    fetchFilterValues = (params, callback) => {
        let that = this
        asyncFilter(params, 'global_filter', callback, that.props.authData, null, null, that.props.dataSet.toolId)
    }
    updateGlobalFilters(e) {
        e.preventDefault();
        let that = this
        let params = {
            "siteId": localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null, "toolId": that.props.dataSet.toolId
        }
        let postData = {
            "userId": that.props.authData.userId, "temporary_filter": that.state.globalFilterValues
        }
        CallAPI('POST', '/app/setGlobalFilter', postData, params, 0, function (response) {
            if (response.status) {
                alert("Filters updated successfully")
                that.props.getGlobalFilters({
                    siteId: params.siteId,
                    toolId: params.toolId,
                    userId: that.props.authData.userId,
                    sessionId: that.props.authData.sessionId
                })
            }
            filtersChanged = false
            jQuery('#globalFilterModal').modal('toggle')
        }, that.props.authData)
    }
    getMenuOptions = (shareButton, dashboardCustomInfo) => {
        let globalFilterLabels = '';
        if (this.props.globalFilters && this.props.globalFilters.length > 0) {
            globalFilterLabels = getGlobalFilterDetails(this.props.globalFilters, true)
        }
        let mobile = window.innerWidth <= tablet_width; 
        let options = <div className="dropdown-menu dropdown-menu-end">
            {/* <a className="dropdown-item" href="#dashSettings" data-toggle="modal" id="saveGridSetting">Style</a> */}
            {/* {globalFilterLabels ? <a className="dropdown-item" href="javascript: false" onClick={() => this.globalFilterHandler()}>Global Filters</a> : null} */}
            {checkIfFeatureApplicable('Download') ? <a className="dropdown-item" href="javascript: false" onClick={() => this.handleModalEvent('exportReport')} id="export_report_button">Export</a> : ''}
            {checkIfFeatureApplicable('Save Report') ? <a className="dropdown-item" href="javascript: false" onClick={() => this.handleModalEvent('saveReport')} id="save_report_button">Save Report</a> : ''}
            {/* <a className="dropdown-item" href="javascript: false" onClick={() => this.handleSyncClick()} id="refresh_button">Refresh Dataset</a> */}
            {checkIfFeatureApplicable('Add Dashboard Filters') ? <a className="dropdown-item" href="javascript: false" onClick={() => this.handleModalEvent('dashboardFilter')} id="dashboardButton">Add Dashboard Filters</a> : ''}
            {dashboard_filters && Object.keys(dashboard_filters).length > 0 ? <a className="dropdown-item" href="javascript: false" onClick={() => this.displayFilters(this.state.filtersVisible ? 'Hide' : 'Show')}>{this.state.filtersVisible ? 'Hide' : 'Show'} Dashboard Filters</a> : null}
            {/* <a className="dropdown-item" href="#" data-toggle="modal" href='#savedReportModal' id="save_report_button">Save Report</a> */}
            <li className="">
                {checkIfFeatureApplicable('Share On Dashboard') || checkIfFeatureApplicable('Rename Dashboard') || checkIfFeatureApplicable('Delete Dashboard') || checkIfFeatureApplicable('Copy Dashboard') || checkIfFeatureApplicable('Duplicate Dashboard') || checkIfFeatureApplicable('Move Dashboard') ? <a className="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" id="action_button" >Actions</a> : ''}
                    <ul className="dropdown-menu dropdown-menu-end">
                        {checkIfFeatureApplicable('Share On Dashboard') ? <li>{shareButton}</li> : ''}
                        {checkIfFeatureApplicable('Rename Dashboard') ? <li><a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('pinboard'), this.handlePinboardEvent('rename'))} id="rename_button">Rename</a></li> : ''}
                        {checkIfFeatureApplicable('Copy Dashboard') ? <li><a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('pinboard'), this.handlePinboardEvent('copy'))} id="copy_button">Copy</a></li> : ''}
                        {checkIfFeatureApplicable('Duplicate Dashboard') ? <li><a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('pinboard'), this.handlePinboardEvent('duplicate'))} id="duplicate_button">Duplicate</a></li> : ''}
                        {checkIfFeatureApplicable('Move Dashboard') ? <li><a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('pinboard'), this.handlePinboardEvent('move'))} id="move_button">Move</a></li> : ''}
                        {checkIfFeatureApplicable('Delete Dashboard') ? <li><a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('pinboard'), this.handlePinboardEvent('delete'))} id="delete_button">Delete</a></li> : ''}
                    </ul>

            </li>
            
            <a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('componentsPerPage'))} id="componentsPerPage">Set Pagination</a>
            {!mobile && <a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('setLayout'))} id="setLayout">Set Layout</a>}
            <a className="dropdown-item" href="javascript: false" onClick={() => dashboardCustomInfo !== null && dashboardCustomInfo.NO_OF_PAGES ? this.handleModalEvent('re_arrangeComponents') : alert('Please Set Pagination To Re-arrange Components')} id="re_arrangeComponents">Re-arrange Components</a>
            {dashboardCustomInfo !== null && dashboardCustomInfo.startDate && dashboardCustomInfo.endDate
                ? <a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('dashboardRange'))} id="dashboardRange">Dashboard Time Range</a>
                : <><a className="dropdown-item" href="javascript: false" id="show_date_info" onClick={() => this.information("show", null)} style={{ display: 'none' }}>Show Date Information</a>
                    <a className="dropdown-item" href="javascript: false" id="hide_date_info" onClick={() => this.information("hide", null)}>Hide Date Information</a></>}
            {/* <a className="dropdown-item" href="javascript: false" onClick={this.information.bind(this, "show", null)}>Show all Information</a>
            <a className="dropdown-item" href="javascript: false" onClick={this.information.bind(this, "hide", null)}>Hide all Information</a> */}
        </div>
        try {
            return options
        } catch (error) {
            console.error("------- Error in Options Loading ---------");
            console.log(error)
            return (<div><h1>Error in Options Loading</h1></div>)
        }
    }
    render() {
        // $('.accordion').accordion({
        //     heightStyle: 'content',
        //     collapsible: true
        // });
        try {
            var that = this, filters = null, shareButton, SettingsComponentVar = null, currentPageComponents = [], dashboardCustomInfo = null, componentsMetaData = null;
            let selectedFilters = that.state.selectedFilters
            let dashboardData = { gridElement: <SkeletonCard /> }

            if (selectedFilters && Object.values(selectedFilters).length === 0 && filtersChanged != true) {
                dashboardComponentsData = null
            }

            if (this.state.dashboardComponents !== -1 && this.state.dashboardComponents.length > 0 && this.state.group === this.state.dashboardComponents[0].dashboard_group) {
                id_dashboard = id_dashboard ? id_dashboard : this.state.dashboard_id;
                dashboardCustomInfo = this.state.dashboardComponents[0].information && this.state.dashboardComponents[0].information !== null
                    ? JSON.parse(this.state.dashboardComponents[0].information)
                    : dashboardCustomInfo
                if (dashboardCustomInfo !== null && dashboardCustomInfo.NO_OF_PAGES) {
                    componentsMetaData = JSON.parse(this.state.dashboardComponents[0].meta_data)
                    this.state.dashboardComponents.filter(function (innerData) {
                        componentsMetaData.filter(function (innervalue) {
                            if (innervalue.page === that.state.currentPage && innerData.iddashboardConfiguration === innervalue.id) {
                                currentPageComponents.push(innerData)
                            }
                        })
                    })
                }
                if ((selectedFilters && Object.values(selectedFilters).length === 0) || filtersAppliedFlag === true) {
                    let componentsToPrepare = currentPageComponents.length > 0 ? currentPageComponents : this.state.dashboardComponents
                    if (filtersChanged != true) {
                        dashboardData = this.prepareDashboardComponents(componentsToPrepare, this)
                        dashboardComponentsData = dashboardData
                    }
                }
                if (this.state.filtersVisible && dashboard_filters && Object.keys(dashboard_filters).length > 0) {
                    let filter_options = Object.keys(dashboard_filters).map(function (innerData, index) {
                        let temp_innerData = innerData;
                        let truncatedFilterName = null
                        if (dashboard_filters[innerData]['label']) {
                            truncatedFilterName = truncateValue(dashboard_filters[innerData]['label'], 28)
                        } else {
                            truncatedFilterName = truncateValue(innerData, 28)
                        }
                        let filter_Name = <span data-placement="bottom" data-toggle="tooltip" className="w-100 text-truncate"title={dashboard_filters[innerData]['label'] ? dashboard_filters[innerData]['label'] : innerData} onMouseEnter={()=>{jQuery('[data-bs-toggle="tooltip"]').tooltip()}}>{`${truncatedFilterName} :`}</span>
                        let filter_Value = dashboardFilterValues === 'empty' ? [] : selectedFilters && selectedFilters[temp_innerData]
                            ? selectedFilters[temp_innerData]
                            : that.state.dimensionFilter && that.state.dimensionFilter.length === 1 && refineURLData(that.state.include) && that.state.include !== "empty" && that.props.selectedFilterValues && that.props.selectedFilterValues[temp_innerData]
                                ? that.props.selectedFilterValues[temp_innerData]
                                : []

                        try {
                            return (
                                <div className='col-md-2 col-sm-4 col-xs-6 mg-b-5 d-flex flex-column' filter="pinboard" id={`dashboard_filter_${index}`} key={`dashboard_filter_${index}`}>
                                    {filter_Name}
                                    <MultiSelect
                                        key={`${temp_innerData}_dropdown_${index}`}
                                        // key={`${temp_innerData}_dropdown_${Math.floor(Math.random() * 10)}`}
                                        className={`${temp_innerData}_dropdown`}
                                        options={that.state.dashboardFilter_options[temp_innerData] ? that.state.dashboardFilter_options[temp_innerData] : []}
                                        value={filter_Value}
                                        onChange={(e) => that.handleDashboardFilters(e, temp_innerData)}
                                        shouldToggleOnHover={false}
                                        isLoading={dropdownStatus}
                                    />
                                </div>
                            )
                        } catch (error) {
                            console.error("------- Error in Render MultiSelect ---------");
                            console.error(error);
                        }
                    });
                    if (filter_options && filter_options.length > 0) {
                        filters = <div className="row" id={`filterTopId${this.state.dashboard_id}`}>
                            {filter_options}
                        </div>
                    }
                }
                // let dashboard_detail = { 'dashboard_id': this.state.dashboard_id, 'userId': this.props.authData ? this.props.authData.userId : null };
                // let defaultConfig = this.state.dashboardComponents[0].dashboard_config;

                // SettingsComponentVar = window.location.pathname.split('/')[1]=="globaldashboards" ? null : <SettingsComponent details={dashboard_detail} dashboard_config={defaultConfig} dashboard_change_handle={this.dashboard_change_handle} dataSet={this.props.dataSet} />
            } else if (actionType == 'pinDelete_NoData') {
                let noData = <span>No more component available. Please start pinning charts to add components here.</span>;
                dashboardData = { gridElement: <h5 className="text-center mg-t-200">{noData}</h5> }
            }

            var tabsList = []; var panelList = []; var activeId = 0; this.dashboardTabArray = []; var index = 0;
            var dashboard_options = this.props.dashbordGroups;

            if (dashboard_options && dashboard_options.length > 0) {
                dashboard_options = dashboard_options.filter(innerData => innerData.type == "local");
                if (window.location.pathname.split('/')[1] == "globaldashboards") {
                    dashboard_options = this.props.allDashboards ? this.props.allDashboards.dashbordGroups : this.props.dashbordGroups;
                    dashboard_options = dashboard_options.filter(innerData => innerData.type == "global");
                }
                dashboard_options.forEach(function (value) {
                    if (value['dashboard_group'] === decodeURIComponent(that.state.group)) {
                        var id = value.idDashboard
                        wrappedChar = value.name.length > 15 ? `${value.name.substring(0, 15)}...` : value.name;
                        tabsList.push(<Tab key={index}><span data-toggle="tooltip" data-placement="bottom" title={value.name} onMouseOver={() => { jQuery('[data-toggle="tooltip"]').tooltip(); }}>{wrappedChar}</span></Tab>)
                        if (id == id_dashboard) {
                            activeId = id == id_dashboard ? index : activeId;
                            panelList.push(<Panel key={index} customStyle={{ padding: "0px" }}>{dashboardComponentsData !== null ? dashboardComponentsData.gridElement : dashboardData.gridElement}</Panel>)
                        } else panelList.push(<Panel key={index}> <span style={{ display: 'flex', justifyContent: "center", alignItems: "center" }} className="spinner">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                        </span>
                        </Panel>)
                        that.dashboardTabArray.push({ index: index++, dashboardId: id, dashboardName: value.name, type: value.type });
                    }
                });
                var reactTabStyle = SKIN_MODE == "dark" ? darkStyle.default : null;
                reactTabStyle = reactTabStyle ? reactTabStyle : (customStyle.default ? customStyle.default : customStyle);
            } else {
                let noData = <LoadingComponent/>;
                dashboardData = { gridElement: <h5 className="text-center mg-t-200">{noData}</h5> }
                panelList.push(<Panel customStyle={{ padding: "0px" }}>{dashboardData.gridElement}</Panel>)
            }

            var share_access_level = null;
            var userShare = [];
            share_enable = this.props.dataSet.userDBSetting ? this.props.dataSet.userDBSetting[0].share_enable : null;
            userType = this.props.dataSet.userType;
            if (refineURLData(share_enable) && JSON.parse(share_enable)) {
                share_access_level = JSON.parse(share_enable)['access'];
                share_access_level = share_access_level ? share_access_level : [{ "userType": 1 }]
                userShare = share_access_level.map(function (element, i) {
                    return element?.userType?.toString();
                });
                if (userShare.indexOf(userType) !== -1 || (userShare[0] && userShare[0].toLowerCase() == "all")) {
                    shareButton = (<a className="dropdown-item" href="javascript: false" onClick={() => (this.handleModalEvent('dashboardShare'))} id="shareDashboard">Share</a>);
                }
            }
            var temp_url = location.pathname.split('/');
            var pagename = temp_url[1];
            var filter = <button type="button" className=" btn btn-sm btn-white" id="filterOpenDiv" onClick={this.openrefs.bind(this)}><i className="fa fa-filter mg-r-2 " style={{ fontSize: "10px" }} ></i></button>
        } catch (error) {
            console.error("------- Error in Render ---------");
            console.error(error);
        }

        let tempuserDBsetting = null
        this.state.dataset_info.userDBSetting ? tempuserDBsetting = this.state.dataset_info.userDBSetting[0] : null;
        let menuOptions = this.getMenuOptions(shareButton, dashboardCustomInfo);
        let isOriginalDate = this.state.dashboardConfigDates?.startDate ? this.state.dashboardConfigDates?.startDate : dynamicStartDate ? dynamicStartDate : tempuserDBsetting ? tempuserDBsetting['dashboardStartTime'] : null;
        isOriginalDate = !isOriginalDate ? true : false

        let calendarButton = <CalenderComponent allPropsData={{ id_dashboard: this.state.dashboard_id, dashboard_group: this.props.group, "currentPageName": "pinboard", pinboard_data: this.props.allDashboards, breakUp: this.state.breakup, breakUpDisp: this.state.dataset_info.breakupDisp, include: this.state.include, includeDisp: this.state.includeArray, exclude: this.state.exclude, excludeDisp: this.state.excludeArray, granularity: this.state.dataset_info.userDBSetting[0].granularity, enableWTD: this.props.dataSet.summarizationDetails[0].granularity, setFiscalYear: this.props.dataSet.userDBSetting[0].FYMonthStart }} startDate={this.state.dashboardConfigDates?.startDate ? this.state.dashboardConfigDates?.startDate : dynamicStartDate ? dynamicStartDate : tempuserDBsetting ? tempuserDBsetting['dashboardStartTime'] : null} endDate={this.state.dashboardConfigDates?.endDate ? this.state.dashboardConfigDates?.endDate : dynamicEndDate ? dynamicEndDate : tempuserDBsetting ? tempuserDBsetting['dashboardEndTime'] : null} startDateDisp={startDate} endDateDisp={endDate} page={this.props.chartCat} datasetDetails={this.props.datasetDetails} granularity={this.state.dataset_info.userDBSetting[0].granularity} dashboardConfigDates={this.props.dashboardConfigDates} pageName={"pinboard"} enableWTD={this.props.dataSet.summarizationDetails[0].granularity} setFiscalYear={this.props.dataSet.userDBSetting[0].FYMonthStart} isOriginalDate={isOriginalDate} />

        let filterCss = screen_width > mobile_width ? "pd-l-5 pd-t-3 pd-b-3" : "pd-l-5 pd-t-3 pd-b-3"

        
        let globalFilterBody = <div className="form-group" id="filter_dropdown">
            <AsyncSelect
                name="globalFilters"
                ref="globalFilters"
                cacheOptions
                loadOptions={this.fetchFilterValues}
                defaultOptions={true}
                value={this.state.globalFilterValues ? this.state.globalFilterValues : this.props.globalFilters}
                onChange={this.globalFilterInputHandler}
                isMulti={true}
            />
        </div>
        let globalFilterModalConfig = { "id": "globalFilterModal", "form_name": "globalFilter", "form_id": "globalFilterForm", "title": "Global Filter", "body": globalFilterBody, "button_name": "Save", "buttonType": "submit", "display": true, "formKey": `globalFilterForm_${Math.floor(Math.random() * 10)}` }
        let mobile = jQuery(document).width() < mobile_width
        let filtersTemp = this.state?.globalFilterValues ? this.state?.globalFilterValues : this.props?.globalFilters
        let workbookInfoPopUp = (
            <div className="popover-container border rounded">
              <div className="popover-header">Global Filter</div>
              <div className="popover-body">
                <div className="popover-section flex">
                  <div className="d-flex flex-wrap">Filters:</div>
                  <div className="d-flex flex-wrap">
                    {filtersTemp.map((filter, index) => (
                      <span key={index} className="badge badge-primary tx-13 mg-2 mr-2">
                        {filter.label}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        try {
            return (
                <div>
                    {/* {SettingsComponentVar} */}
                    <div id='mainDIVS'>
                        {panelList ?
                            <Tabs customStyle={reactTabStyle} onTabChange={this.dashboardreindex} key={id_dashboard} activeIndex={activeId} showModalButton={true}>
                                <div className="d-flex flex-wrap justify-content-between w-100" style={{ borderBottom: "0.5px solid  #cedfed", marginBottom: "7px", marginTop: 2 }}>

                                    {/* Breadcrumb */}
                                    <div className="d-flex align-items-center w-40">
                                        <div className="mr-auto m-0 d-flex align-items-center" style={{ position: "relative" }}>
                                            <BreadcrumbComponent props={this.props}  handleGlobalFilter={this.globalFilterHandler}  handleSync={this.handleSyncClick} onDashboardChange={this.dashboardreindex} currentPageName='pinboard' stateData={this.state} dashboardTabArray={this.dashboardTabArray} mobile={mobile} datasetTruncate={mobile ? 'text-truncate wd-50':''} />
                                        </div>
                                    </div>
                                    {actionType != 'pinDelete_NoData'
                                        ? <div className={`d-flex pd-r-0 align-items-center w-60`}>
                                            {/* Global filter button */}
                                            {/* {globalFilterLabels
                                                ? <button type="button" data-toggle="tooltip" data-placement="top" title={globalFilterLabels} class="btn btn-outline-warning pd-8 mg-l-5 mg-t-3 mg-b-3 float-right tx-medium tx-12 tx-sans btn-outline-warning" onMouseOver={() => jQuery('[data-toggle="tooltip"]').tooltip()} onClick={() => this.globalFilterHandler()}>Global Filters <span><i class="feather" data-feather="filter"></i></span></button>
                                                : null} */}

                                            {/* Performance Icon */}
                                            {/* {this.state.dashboardComponents !== -1 && (dashboardCustomInfo === null || !dashboardCustomInfo.NO_OF_PAGES) && screen_width >= mobile_width ?
                                                <span className=" alert-primary pd-6 mg-t-3 mg-b-3 float-right tx-medium tx-12 tx-sans" title="To Improve Dashboard Performance, Please Set Pagination." style={{ cursor: 'pointer', borderRadius: '3px', }} onClick={() => this.handleModalEvent('componentsPerPage')}>
                                                    <i data-feather="alert-circle" className="mg-r-0" width="20" height="20" ></i></span>
                                                : null} */}
                                            {/* {filtersTemp.length > 0 ? (
                                                <a
                                                    tabIndex="0"
                                                    className="alert-primary pd-6 mg-t-3 mg-b-3 float-right tx-medium tx-12 tx-sans mg-r-3 rounded"
                                                    role="button"
                                                    data-bs-toggle="popover"
                                                    data-bs-trigger="focus"
                                                    data-bs-html="true"
                                                    data-bs-content={ReactDOMServer.renderToString(workbookInfoPopUp)}
                                                    id="popoverTrigger"
                                                >
                                                    <i
                                                        data-feather="alert-circle"
                                                        className="pinboard-info-icon feather mg-r-0"
                                                        width="20"
                                                        height="20"
                                                    ></i>
                                                </a>
                                            ) : null} */}
                                            <div className=" pd-t-3 pd-b-3">
                                                {calendarButton}
                                            </div>
                                            {/* <a tabindex="0" class="btn btn-lg btn-danger" role="button" data-toggle="popover" data-trigger="focus" title="Dismissible popover" data-content="And here's some amazing content. It's very engaging. Right?">Dismissible popover</a> */}
                                            {/* More dropdown */}
                                            <div className="pd-l-5 pd-t-3 pd-b-3">
                                                <button className="btn btn-sm btn-white  dropdown-toggle"
                                                    id="top_more_action_button"
                                                    data-bs-auto-close="outside"
                                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More</button>
                                                {menuOptions}
                                            </div>

                                            {/*Filter Settings */}
                                            <div className={filterCss}>
                                                {filter}
                                            </div>
                                        </div>
                                        : null}
                                </div>
                                {this.props.dashboardUIType == 'tabs'
                                    ? <TabList>{tabsList}</TabList>
                                    : <div />}
                                <div style={{ display: `${filters && that.state.filtersVisible ? 'contents' : 'none'}` }}>
                                    <div className={`card ${this.props.dashboardUIType == 'tabs' ? 'mg-t-7' : 'mg-b-7'}`}>
                                        {/* <div className="accordion"> */}
                                        <div className="col-lg-12 mg-t-5">
                                            {filters}
                                        </div>
                                        <div className="col-lg-12 mg-b-5">
                                            <button className="float-right btn-xs btn btn-primary" id="apply_filter" onClick={() => this.handleApplyFilters()}>Apply Filters</button>
                                            <button className="float-right mg-r-5 btn-xs btn btn-primary" id="hide_filter" onClick={() => this.displayFilters('Hide')}>Hide</button>
                                        </div>
                                    </div>
                                    </div>
                                {/* </div> */}
                                <PanelList>{panelList}</PanelList>

                                {/* Pagination Code */}
                                {dashboardCustomInfo !== null && dashboardCustomInfo.NO_OF_PAGES
                                    ? <div className="d-flex row justify-content-center p-2">
                                        <Pagination
                                            currentPage={this.state.currentPage}
                                            totalPages={dashboardCustomInfo.NO_OF_PAGES ? dashboardCustomInfo.NO_OF_PAGES : componentsMetaData ? componentsMetaData[componentsMetaData.length - 1].page : 0}
                                            paginate={this.paginate}
                                            nextPagePaginate={this.nextPagePaginate}
                                            previousPagePaginate={this.previousPagePaginate}
                                        />
                                    </div>
                                    : <div />}
                            </Tabs>
                            : <>
                                <div className="mg-t-5 p-2">
                                    <div className="mr-auto m-0 d-flex align-items-center" style={{ position: "relative" }}>
                                        <BreadcrumbComponent props={this.props}  handleGlobalFilter={this.globalFilterHandler} handleSync={this.handleSyncClick} onDashboardChange={this.dashboardreindex} currentPageName='pinboard' stateData={this.state} dashboardTabArray={this.dashboardTabArray} />
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-center justify-content-center">
                                    {/* <h1 className={"tx-color-01 tx-24 tx-sm-32 mg-xl-b-5 tx-lg-20"}>{'No Components to load. Kindly create new dashboard'}</h1> */}
                                    {<NoDataFound data='No Components to load. Kindly create new dashboard.' hideImg={false} status={-1} style={false} />}
                                </div>
                            </>}
                        {this.state.modalName && this.state.modalName === 'exportReport' && window.location.pathname === '/pinboard' && this.state.dashboardConfigDates.startDate === null && this.state.dashboardConfigDates.endDate === null
                            ? alert('Please select date range!')
                            : (this.state.modalName && this.state.modalName !== null
                                ? <TopModalComponent modalEventName={this.state.modalName} allPropsData={{ id_dashboard: this.state.dashboard_id, dashboard_group: this.props.group, "currentPageName": "pinboard", pinboard_data: this.props.allDashboards, breakUp: this.state.breakup, breakUpDisp: this.state.dataset_info.breakupDisp, include: this.state.include, includeDisp: this.state.includeArray, exclude: this.state.exclude, excludeDisp: this.state.excludeArray, dashboardStartDate: this.state.dashboardConfigDates.startDate, dashboardEndDate: this.state.dashboardConfigDates.endDate }} handleModalEvent={this.handleModalEvent} pinboardEvent={this.state.pinboardEventName} dimensionFilter={this.state.dimensionFilter} dimensionFilterhandle={this.dimensionFilterhandle} addDashboardFilter={this.addDashboardFilter} fetchPropertyData={this.fetchPropertyData} dashboardComponents={this.state.dashboardComponents} getComponentsAPI={this.get_components} dashboardCustomInfo={dashboardCustomInfo} allProps={this.props} allStates={this.state} datasetSyncClick={this.handleSyncClick} cancelEventHandler={this.dashboardFilterCancelHandler}/>
                                : null)}
                    </div>
                    {editComponentModal}
                    {<ModalComponent modalConfig={globalFilterModalConfig} action={this.updateGlobalFilters} />}
                </div>
            )
        } catch (error) {
            console.error("------- Error in Render Return ---------");
            console.error(error);
        }
    }
}

function mapStateToProps(state) {
    var url_string = location.href; //window.location.href
    var url = new URL(url_string);
    var group = url.searchParams.get("group");

    var chartvalues = state.summary.chartValues[0];
    var metricValue = "";
    var property = "";
    var breakup = "";
    var include = "";
    var dataLabelConfig = null;
    var exclude = "";
    var id_dashboard = state.dataSet.id_dashboard;
    var alfred_question = state.alfred.alfred_question;
    if (chartvalues) {
        metricValue = chartvalues && chartvalues.metrics !== undefined ? chartvalues.metrics : [];
        property = chartvalues !== undefined && chartvalues.property !== undefined ? chartvalues.property : [];
        breakup = chartvalues !== undefined && chartvalues.breakup !== undefined ? chartvalues.breakup : [];
    }

    metricValue = decodeURIComponent(metricValue);

    var initial_data_from_url = {};
    initial_data_from_url = getURLDataHandle();
    property = initial_data_from_url.property ? initial_data_from_url.property : ''
    breakup = initial_data_from_url.breakup ? initial_data_from_url.breakup : ''
    metricValue = initial_data_from_url.metric ? initial_data_from_url.metric : ''
    include = initial_data_from_url.include && initial_data_from_url.include != "null" ? initial_data_from_url.include : (state.dataSet.include && state.dataSet.include.length != 0 ? state.dataSet.include : null);
    exclude = initial_data_from_url.exclude && initial_data_from_url.exclude != "null" ? initial_data_from_url.exclude : (state.dataSet.exclude && state.dataSet.exclude != 0 ? state.dataSet.exclude : null);
    id_dashboard = initial_data_from_url.dashboard_id && initial_data_from_url.dashboard_id != "null" ? initial_data_from_url.dashboard_id : id_dashboard;
    if (globalDashboardID === null) {
        globalDashboardID = id_dashboard;
    }
    // if (state.dataSet.metric) {
    //     metricValue = state.dataSet.metric
    // }
    // if (state.dataSet.property) {
    //     property = state.dataSet.property
    // }
    // if (state.dataSet.breakup) {
    //     breakup = state.dataSet.breakup
    // }
    metricGlobal = state.dataSet.metricGlobal;
    metricFunction = state.dataSet.metricFunction;
    dataLabelConfig = state.dataSet.dataLabelConfig;
    document.title = `Dashboard | Cognitive Analytics Platform`;

    let newURL = window.location.pathname.split("/");
    group = newURL ? newURL[2] === undefined ? newURL[2] : decodeURIComponent(newURL[2]) : "default";

    var dashboardUIType = null
    if (state.dataSet.authData && IsJsonString(state.dataSet.authData.extraInfo)) {
        let parsedInfo = JSON.parse(state.dataSet.authData.extraInfo)
        dashboardUIType = parsedInfo && parsedInfo.dashboard_display_type == 'tabs' ? 'tabs' : null
    }

    return {
        authData: state.dataSet.authData,
        dashboardUIType: dashboardUIType,
        dataResult: state.dataSet.dataResult,
        metricGlobal: state.dataSet.metricGlobal,
        metricFunction: state.dataSet.metricFunction,
        dataLabelConfig: state.dataSet.dataLabelConfig,
        selectedMetric: metricValue,
        property: property,
        dashboardProperty: state.dataSet.dashboardProperty,
        alfred_question: alfred_question,
        propertyArray: state.summary.property,
        dataSet: state.dataSet.dataSet,
        breakup: breakup,
        filter: state.dataSet.filter,
        insight: state.dataSet.insight,
        insightPoint: state.dataSet.point,
        dimensionFilter: state.dataSet.dimensionFilter,
        dataset_info: state.dataSet,
        propertyDisp: state.summary.propertyDisp,
        SelectedBreakUpDisp: [],
        id_dashboard: id_dashboard,
        report_name: state.dataSet.report_name,
        dashboardComponents: state.dataSet.dashboardComponents && state.dataSet.dashboardComponents.length > 0
            ? globalDashboardID === state.dataSet.dashboardComponents[0].idDashboard
                ? state.dataSet.dashboardComponents
                : -1
            : [],
        group: group ? group : state.dataSet.group,
        dashbordGroups: state.dataSet.dashbordGroups,
        initialDataApiFlag: state.dataSet.initialDataApiFlag,
        globalFilters: state.dataSet.globalFilters,
        // include: state.dataSet.include && state.dataSet.include.length != 0 ? state.dataSet.include : null,
        include: include,
        includeArray: state.dataSet.includeDisp,
        // exclude: state.dataSet.exclude,
        exclude: exclude,
        excludeArray: state.dataSet.excludeDisp,
        dashboardConfigDates: state.dataSet.dashboard,
        allProperty: state.dataSet?.alfred?.property,
        allMetric: state.dataSet.allMetric,
        allDBSettingsData: state.dataSet.allDBSettingsData,
        allDashboards: state.dataSet.allDashboards,
        dashboard: state.dataSet.pinboardDashboard,
        allHierarchyValues: state.dataSet.allHierarchyValues,
        dashboardConfig: state.dataSet.dashboardConfig ? state.dataSet.dashboardConfig : { "legend": true, "gridline": false, "x_axis": true, "y_axis": true, "x_axis_label": true, "y_axis_label": true, "data_labels": true, "information": true, "colorArray": null },
        selectedFilterValues: state.dataSet.selectedFilterValues,
        // dashboardCustomInfo: state.dataSet.dashboardCustomInfo
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setDashboardId, setFilter, removeFilter, set_disp_objects,setKpiColumnConfig, getGlobalFilters, setInsightFunction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Pinboard);